<template>
  <div class="trip-details mt-4 page-heading">
    <h2>Trip Details</h2>
  </div>
  <div>
    <div class="card mt-4">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <b>TR Summary</b>
          </div>
          <div class="col">
            <p
              data-bs-toggle="collapse"
              id="button-on-click"
              data-bs-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
              style="margin-right: 10px"
            >
              <i
                v-if="collapsedown"
                @click="collapseDown"
                class="bi bi-arrow-down float-end"
              ></i>
              <i
                v-if="collapseup"
                @click="collapseUp"
                class="bi bi-arrow-up float-end"
              ></i>
            </p>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="col-12">
          <div class="row" id="blockDisplay">
            <div class="col-4">
              <b>Route</b>
              <p>{{ countStats ? countStats.route_name : 'N/A' }}</p>
            </div>
            <div class="col-4">
              <b>Parent Route</b>
              <p>
                {{ tripRequest ? tripRequest.parent_route_name : 'N/A' }}
              </p>
            </div>
            <div class="col-3">
              <b>Status</b>
              <!--              <p>{{ tripRequest ? tripRequest.status : 'N/A' }}</p>-->
              <div class="col-sm-6">
                <div class="row">
                  <select
                    v-model="tripRequest.status"
                    @change="tripStatusChange($event)"
                    class="form-select form-select-sm"
                  >
                    <option value="Closed">Closed</option>
                    <option value="Published">Published</option>
                    <option value="Unpublished">Unpublished</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="collapse" id="collapseExample">
            <div class="row">
              <div class="col-md-2">
                <b>Route</b>
                <p>{{ tripRequest ? tripRequest.route_name : 'N/A' }}</p>
              </div>
              <div class="col-md-2">
                <b>Parent Route</b>
                <p>
                  {{ tripRequest ? tripRequest.parent_route_name : 'N/A' }}
                </p>
              </div>
              <div class="col-md-1">
                <b>Type</b>
                <p>{{ tripRequest ? tripRequest.tripType : 'N/A' }}</p>
              </div>
              <div class="col-md-1">
                <b>Distance</b>
                <p>{{ tripRequest ? tripRequest.distance : 'N/A' }}</p>
              </div>
              <div class="col-md-2">
                <b>Home Pickup</b>
                <p>
                  {{
                    tripHomeTimeFormatData.length > 0
                      ? tripHomeTimeFormatData
                      : 'N/A'
                  }}
                </p>
              </div>
              <div class="col-md-2">
                <b>Office Pickup</b>
                <p>
                  {{
                    tripOfficeTimeFormatData.length > 0
                      ? tripOfficeTimeFormatData
                      : 'N/A'
                  }}
                </p>
              </div>
              <div class="col-md-2">
                <b>Status</b>
                <!--                  <p>{{ tripRequest ? tripRequest.status : 'N/A' }}</p>-->
                <p>
                  <select
                    v-model="tripRequest.status"
                    @change="tripStatusChange($event)"
                    class="form-select form-select-sm"
                  >
                    <option value="Closed">Closed</option>
                    <option value="Published">Published</option>
                    <option value="Unpublished">Unpublished</option>
                  </select>
                </p>
              </div>

              <div class="w-100"></div>
              <div class="col-md-2">
                <b>Daily Price</b>
                <p class="text-capitalize">
                  Fare:
                  {{ Math.round(tripRequest.price / tripRequest.working_days) }}
                  BDT
                </p>
                <p class="text-capitalize">
                  {{ getDailyBonusCalculation }}
                </p>
              </div>

              <div class="col-md-2">
                <b>Weekly Price</b>
                <p class="text-capitalize">
                  <!--                    {{-->
                  <!--                      tripRequest-->
                  <!--                        ? `${new Intl.NumberFormat('en-IN', {-->
                  <!--                          style: 'currency',-->
                  <!--                          currency: 'BDT'-->
                  <!--                        }).format(tripRequest.price)}`-->
                  <!--                        : 'N/A'-->
                  <!--                    }}-->
                  Fare:
                  {{ tripRequest.price ? tripRequest.price : 'N/A' }} BDT
                </p>
                <p class="text-capitalize">
                  {{ getWeeklyBonusCalculation }}
                </p>
              </div>

              <div class="col-md-2">
                <b>Bonus</b>
                <p v-if="tripRequest.bonus">{{ tripRequest.bonus }}</p>
                <p v-else id="listOfBonus">
                  <!--                    {{-->
                  <!--                      tripRequest-->
                  <!--                        ? `${new Intl.NumberFormat('en-IN').format(-->
                  <!--                          tripRequest.bonus-->
                  <!--                        )} BDT`-->
                  <!--                        : 'N/A'-->
                  <!--                    }}-->
                  {{ getBonusWithPrice }}
                  <!--                    <span v-for='(b, index) in getBonusWithPrice' :key='index + Math.random()' class='fw-normal'>-->
                  <!--                      {{ b ? b : 'N/A' }}-->
                  <!--                      <br />-->
                  <!--                    </span>-->
                </p>
              </div>
              <div class="col-auto">
                <b>Workdays</b>
                <p>
                  {{
                    tripRequest
                      ? tripRequest.week_days +
                        '(' +
                        tripRequest.working_days +
                        ')'
                      : 'N/A'
                  }}
                </p>
              </div>
              <div class="col-md-3">
                <b>Instruction For TM</b>
                <p>
                  {{ tripRequest ? tripRequest.instruction_for_tm : 'N/A' }}
                </p>
              </div>
              <div class="col-md-3">
                <b>Trip Request ID</b>
                <p>
                  {{ tripRequest ? tripRequest.trip_code : 'N/A' }}
                </p>
              </div>
              <div class="col-md-3">
                <b>Trip Start Date</b>
                <p>
                  {{ tripRequest ? tripRequest.trip_start_date : 'N/A' }}
                </p>
              </div>
              <div class="col-md-3">
                <b>Trip Type</b>
                <p>
                  {{ tripRequest ? tripRequest.route_type : 'N/A' }}
                </p>
              </div>
              <div class="w-100"></div>
              <div class="col-md-2">
                <b>Instruction For Partner</b>
                <p>
                  {{ tripRequest ? tripRequest.instruction_for_sp : 'N/A' }}
                </p>
              </div>
              <div class="col-md-10">
                <b>Pickup points</b>
                <br />
                <p
                  class="d-inline-flex ml-2"
                  v-for="(pickupData, index) in pickupData"
                  :key="pickupData.id"
                >
                  <span
                    >{{ pickupData.name
                    }}<i
                      class="bi bi-arrow-right"
                      style="margin-right: 10px; margin-left: 10px"
                      :class="pickLength == index ? 'd-none' : ''"
                    ></i
                  ></span>
                </p>
              </div>
              <div class="col">
                <b>Dropoff points</b>
                <br />
                <p
                  class="d-inline-flex ml-2"
                  v-for="(dropoffData, index) in dropoffData"
                  :key="dropoffData.id"
                >
                  <span
                    >{{ dropoffData.name
                    }}<i
                      class="bi bi-arrow-right"
                      style="margin-right: 10px; margin-left: 10px"
                      :class="dropLength == index ? 'd-none' : ''"
                    ></i
                  ></span>
                </p>
              </div>
              <div class="col">
                <b></b>
                <button
                  type="button"
                  class="btn-sm btn btn-primary"
                  data-bs-toggle="modal"
                  @click="getAllTrSummaryData"
                  data-bs-target="#trSummaryEdit"
                >
                  <i class="bi bi-pencil-square"></i> Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="partner-stats mt-4 page-heading" style="padding: 0px">
      <h2>Partner Stats</h2>
    </div>
    <div class="my-4" style="padding: 0px">
      <div class="row text-center partner-state">
        <div class="col-xl-2">
          <div class="border">
            <p>Invited</p>
            <p>
              <b>{{ countStats.invited }}</b>
            </p>
          </div>
        </div>
        <div class="col-xl-2">
          <div class="border">
            <p>Responded</p>
            <p>
              <b>{{ countStats.responded }}</b>
            </p>
          </div>
        </div>
        <div class="col-xl-8 state">
          <div class="row">
            <div class="col-md-3">
              <div class="status">
                <p>Called</p>
                <p>
                  <b>{{ countStats.called }}</b>
                </p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="status">
                <p>Confirmed</p>
                <p>
                  <b>{{ countStats.confirmed }}</b>
                </p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="status">
                <p>Unique Call</p>
                <p>
                  <b>{{ countStats.uniqueCall }}</b>
                </p>
              </div>
            </div>
            <div class="col-md-3 col-md-3 decline">
              <div class="status">
                <p>Assigned</p>
                <p>
                  <b>{{ countStats.assigned }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-custom card-transparent" style="margin-bottom: 70px">
      <div class="card-body">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-2">
              <h6>Invited Partners</h6>
            </div>
            <div class="col-sm-8">
              <form @submit.prevent="searchData">
                <div class="row">
                  <div
                    class="col-lg-2"
                    v-show="
                      this.permission.includes(
                        'trip-details-invite-partner'
                      ) === true
                    "
                  >
                    <button
                      type="button"
                      @click="redirectToInvitePartnerPage"
                      class="btn btn-primary btn-sm"
                      id="invitePartnerButton"
                    >
                      Invite Partner
                    </button>
                  </div>
                  <div
                    class="col-lg-2"
                    v-show="
                      this.permission.includes(
                        'trip-details-search-with-name'
                      ) === true
                    "
                  >
                    <div class="input-group-sm">
                      <input
                        class="form-control"
                        type="search"
                        v-model="user_service.name"
                        placeholder="Search with name"
                        aria-label="Search"
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-2"
                    v-show="
                      this.permission.includes(
                        'trip-details-search-with-mobile'
                      ) === true
                    "
                  >
                    <div class="input-group-sm">
                      <input
                        class="form-control"
                        type="search"
                        v-model="user_service.mobile"
                        placeholder="Search with mobile"
                        aria-label="Search"
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-2"
                    v-show="
                      this.permission.includes(
                        'trip-details-partner-info-search'
                      ) === true
                    "
                  >
                    <div class="input-group-sm">
                      <input
                        class="form-control"
                        type="search"
                        v-model="global_search"
                        placeholder="partner info search"
                        aria-label="Search"
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-2"
                    v-show="
                      this.permission.includes(
                        'trip-details-partner-info-search'
                      ) === true ||
                      this.permission.includes(
                        'trip-details-search-with-mobile'
                      ) === true ||
                      this.permission.includes(
                        'trip-details-search-with-name'
                      ) === true
                    "
                  >
                    <button class="btn btn-primary btn-sm" @submit="searchData">
                      Search
                    </button>
                  </div>
                  <div class="col-lg-2">
                    <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#assignDriversToTripModal"
                    >
                      Assign Partner
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div
              class="col-sm-2 float-start"
              v-show="this.permission.includes('trip-details-filter') === true"
            >
              <select
                class="form-select form-select-sm"
                v-model="filterPartnerStatus"
                @change="partnerListFilter"
              >
                <option value="">All</option>
                <option value="Interested">Interested</option>
                <option value="Confirmed">Confirmed</option>
                <option value="Assigned">Assigned</option>
                <option value="Accepted">Accepted</option>
                <option value="Invited">Invited</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="isLoading" class="container">
          <div class="d-flex justify-content-center mt-5">
            <loader></loader>
          </div>
        </div>
        <div v-else>
          <div v-if="invitedPartnerList.length > 0" class="table-responsive">
            <table class="table mt-3" id="ipl">
              <thead class="table-light">
                <tr>
                  <th>Badge</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Vehicle Type</th>
                  <th>Talked</th>
                  <th>Garage Location</th>
                  <th>Partner Type</th>
                  <th>Status</th>
                  <th>Driver Type</th>
                  <th>Call Status</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="ipl in invitedPartnerList" :key="ipl.id">
                  <tr @click="checkVisibility(ipl.id)" class="row-click">
                    <td>
                      <div class="row">
                        <div class="col-7">
                          <img
                            src="../../assets/Vector.png"
                            alt="badge-icon"
                            v-show="ipl.bedge ? ipl.bedge === 'Active' : ''"
                          />
                        </div>
                        <div class="col-5">
                          <p v-if="!opened.includes(ipl.id)">
                            <i class="bi bi-chevron-right"></i>
                          </p>
                          <p v-else>
                            <i class="bi bi-chevron-down"></i>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <router-link
                        :to="`/trip-request/partners/profile/${ipl.partner_id}`"
                      >
                        {{
                          driverDetails.find(
                            (driver) => driver.user_code === ipl.partner_id
                          )
                            ? driverDetails.find(
                                (driver) => driver.user_code === ipl.partner_id
                              ).name
                            : 'No User Found'
                        }}
                      </router-link>
                    </td>
                    <td>
                      {{
                        driverDetails.find(
                          (driver) => driver.user_code === ipl.partner_id
                        )
                          ? driverDetails.find(
                              (driver) => driver.user_code === ipl.partner_id
                            ).mobile
                          : 'No Mobile Found'
                      }}
                    </td>
                    <td>{{ ipl.car_type }}</td>
                    <td>{{ ipl.talked }}</td>
                    <td>{{ ipl.garage_location }}</td>
                    <td>{{ ipl.partner_type }}</td>
                    <td>{{ ipl.status }}</td>
                    <td>{{ ipl.backup_partner ? 'Backup' : 'Regular' }}</td>
                    <td>
                      <i
                        :class="`bi bi-${
                          ipl.talked > 0 ? 'telephone-fill' : 'telephone'
                        }`"
                      ></i>
                    </td>
                  </tr>
                  <tr v-if="opened.includes(ipl.id)">
                    <td colspan="10">
                      <div class="row">
                        <div class="col-md-2">
                          <h6 class="contract-text">Contract Details</h6>
                          <span class="contract-deal">
                            <small class="contract-deal-text"
                              >Price:
                              {{
                                new Intl.NumberFormat('en-IN').format(
                                  ipl.price
                                ) || 0
                              }}
                              BDT; Bonus:
                              <!--                                {{-->
                              <!--                                  new Intl.NumberFormat('en-IN').format(-->
                              <!--                                    ipl.bonus-->
                              <!--                                  ) || 0-->
                              <!--                                }}-->
                              {{ ipl.bonus ? ipl.bonus : sumBonusAmount }}
                              BDT;</small
                            >
                            <div class="contract-deal-icon mb-1">
                              <i
                                class="bi bi-pencil-square"
                                data-bs-toggle="modal"
                                data-bs-target="#contractDetailsModal"
                                @click="
                                  editContractDetails(ipl.id, ipl.partner_id)
                                "
                              ></i>
                            </div>
                          </span>
                        </div>
                        <div class="col-md-2">
                          <h6 class="remarks">Remarks</h6>
                          <span class="remarks-section">
                            <small class="remarks-text"> Remarks added</small>
                            <div class="remarks-icons mb-1">
                              <i
                                class="bi bi-plus"
                                data-bs-toggle="modal"
                                data-bs-target="#addRemarksModal"
                                @click="createNewRemarks(ipl.id)"
                              ></i>
                              <i
                                class="bi bi-eye mr-3"
                                data-bs-toggle="modal"
                                data-bs-target="#remarkDetailsModal"
                                @click="getRemarksList(ipl.id)"
                              ></i>
                            </div>
                          </span>
                        </div>
                        <div class="col-md-2">
                          <h6 class="talk">Talked</h6>
                          <span class="talk-section">
                            <small class="talk-text"
                              >Talked {{ ipl.talked }} times</small
                            >
                            <div class="talk-icons mb-1">
                              <i
                                class="bi bi-plus"
                                data-bs-toggle="modal"
                                data-bs-target="#conversionCreateModal"
                                @click="
                                  createNewTalkTalked(ipl.id, ipl.partner_id)
                                "
                              ></i>
                              <i
                                class="bi bi-eye"
                                data-bs-toggle="modal"
                                data-bs-target="#viewTalkModal"
                                @click="viewCall(ipl.id)"
                              ></i>
                            </div>
                          </span>
                        </div>
                        <div
                          class="col-md-4"
                          v-if="!(ipl.status === 'Invited')"
                        >
                          <h6
                            class="confirm-text"
                            v-if="ipl.status === 'Interested'"
                          >
                            Confirm Partner
                          </h6>

                          <h6
                            class="confirm-text"
                            v-if="ipl.status === 'Confirmed'"
                          >
                            Accepted Partner
                          </h6>

                          <h6
                            class="confirm-text"
                            v-if="ipl.status === 'Accepted'"
                          >
                            Assign Partner
                          </h6>

                          <h6
                            class="confirm-text"
                            v-if="ipl.status === 'Assigned'"
                          >
                            Unassigned Partner
                          </h6>

                          <button
                            class="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#confirm-modal-show"
                            v-if="ipl.status === 'Interested'"
                            @click="confirmButton(ipl.partner_id, ipl.id)"
                          >
                            Confirm
                          </button>

                          <button
                            class="confirm-button"
                            data-bs-toggle="modal"
                            data-bs-target="#confirm-modal-show"
                            :class="{
                              'opacity-50': ipl.status === 'Confirmed'
                            }"
                            v-if="ipl.status === 'Confirmed'"
                            @click="confirmButton(ipl.partner_id, ipl.id)"
                            :disabled="ipl.status === 'Confirmed'"
                          >
                            Accepted
                          </button>

                          <!--<<<<<<< HEAD-->
                          <!--&lt;!&ndash;                          <button&ndash;&gt;-->
                          <!--&lt;!&ndash;                            class='confirm-button'&ndash;&gt;-->
                          <!--&lt;!&ndash;                            data-bs-toggle='modal'&ndash;&gt;-->
                          <!--&lt;!&ndash;                            data-bs-target='#check-assign-modal-show'&ndash;&gt;-->
                          <!--&lt;!&ndash;                            v-if="ipl.status === 'Accepted'"&ndash;&gt;-->
                          <!--&lt;!&ndash;                            @click='checkAssignedStatus(ipl.partner_id, ipl.id)'&ndash;&gt;-->
                          <!--&lt;!&ndash;                          >&ndash;&gt;-->
                          <!--&lt;!&ndash;                            Assign&ndash;&gt;-->
                          <!--&lt;!&ndash;                          </button>&ndash;&gt;-->
                          <!--                          <button-->
                          <!--                            class='confirm-button'-->
                          <!--                            :class="{-->
                          <!--                                'opacity-50': ipl.status === 'Assigned'-->
                          <!--                              }"-->
                          <!--                            data-bs-toggle='modal'-->
                          <!--                            data-bs-target='#confirm-modal-show'-->
                          <!--                            v-else-->
                          <!--                            :disabled="ipl.status === 'Accepted'"-->
                          <!--                          >-->
                          <!--                            Assign-->
                          <!--                          </button>-->
                          <button
                            class="confirm-button"
                            v-if="ipl.status === 'Accepted'"
                            @click="
                              checkAssignedDriveToTrip(ipl.partner_id, ipl.id)
                            "
                          >
                            Assign
                          </button>
                          <button
                            class="btn btn-secondary"
                            v-if="ipl.status === 'Assigned'"
                            disabled
                          >
                            Assigned
                          </button>
                          <button
                            class="btn btn-danger"
                            style="margin-left: 10px"
                            v-if="ipl.status === 'Assigned'"
                            @click="
                              confirmUnassignedButton(ipl.partner_id, ipl.id)
                            "
                          >
                            Unassign
                          </button>
                        </div>
                        <div class="col-md-2" v-if="ipl.status === 'Invited'">
                          <h6>Resend sms to invite</h6>
                          <button
                            class="btn btn-sm btn-primary"
                            @click="
                              confirmReSendSms(
                                ipl.partner_id,
                                driverDetails.find(
                                  (driver) =>
                                    driver.user_code === ipl.partner_id
                                ).mobile
                              )
                            "
                          >
                            Resend SMS
                          </button>
                        </div>
                        <!-- <div class="col-md-2">
                          <button
                            class="btn btn-primary"
                            style="margin-top: 32px"
                            @click="
                              makeOwner(
                                driverDetails.find(
                                  (driver) =>
                                    driver.user_code === ipl.partner_id
                                )
                              )
                            "
                          >
                            Make Owner
                          </button>
                        </div> -->
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div v-else>
            <p class="mt-3 alert alert-danger" style="text-align: center">
              No Data Found 😢
            </p>
          </div>
        </div>
        <div class="" style="float: left">
          <p>Showing {{ this.from }}-{{ this.to }} out of {{ this.total }}</p>
        </div>
        <!-- Paginate -->
        <div>
          <template v-if="isFilterOrNot">
            <paginate
              :totalPages="totalPages"
              :total="total"
              :currentPage="currentPage"
              :perPage="perPage"
              v-on:pagechanged="filtering"
            ></paginate>
          </template>
          <template v-else>
            <paginate
              :totalPages="totalPages"
              :total="total"
              :currentPage="currentPage"
              :perPage="perPage"
              v-on:pagechanged="getTripRequest"
            ></paginate>
          </template>
        </div>
      </div>
      <div
        class="modal fade"
        id="viewTalkModal"
        tabindex="-1"
        aria-labelledby="viewTalkLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="viewTalkLabel">Call Details List</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div class="modal-body">
              <div class="col-md-12">
                <div v-if="isLoadingCall" class="container">
                  <div class="d-flex justify-content-center mt-5">
                    <loader></loader>
                  </div>
                </div>
                <div v-else>
                  <div v-if="this.conversationLists.length > 0">
                    <table
                      class="table table-bordered"
                      id="conversion-detail-table"
                    >
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th>Call Note Type</th>
                          <th>Called By</th>
                          <th>Call Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(conversationList, index) in conversationLists"
                          v-bind:key="conversationList.id"
                        >
                          <td>{{ ++index }}</td>
                          <td>{{ conversationList.call_note_type }}</td>
                          <td>{{ conversationList.called_by }}</td>
                          <td>{{ conversationList.call_date }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else>
                    <p class="alert alert-danger">No Data Found 😢</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="addRemarksModal"
        tabindex="-1"
        aria-labelledby="addRemarksLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addRemarksLabel">Add Remarks</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div class="modal-body">
              <div class="container">
                <form @submit.prevent="submitRemark">
                  <div class="col">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label"
                        >Conversation Type</label
                      >
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        style="margin-right: 10px"
                        v-model="this.remarksForm.preset_remark_id"
                      >
                        <option value="">Select One</option>
                        <option
                          v-for="setRemark in setRemarks"
                          :key="setRemark.id"
                          :value="setRemark.id"
                        >
                          {{ setRemark.preset_remark_type }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-3">
                      <label
                        for="exampleFormControlTextarea1"
                        class="form-label"
                        >Instructions</label
                      >
                      <textarea
                        class="form-control"
                        placeholder="Write Here"
                        id="exampleFormControlTextarea1"
                        rows="1"
                        v-model="this.remarksForm.remarks"
                      ></textarea>
                    </div>
                    <div class="mb-3">
                      <label for="remarkedByInputField" class="form-label"
                        >Remarked By</label
                      >
                      <input
                        type="name"
                        class="form-control"
                        id="remarkedByInputField"
                        v-model="this.remarksForm.remarked_by"
                        placeholder="Remarks By"
                      />
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      id="remarksSubmitBtn"
                      data-bs-dismiss="modal"
                      :class="{ disabled: remarkValidation }"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="remarkDetailsModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="remarkDetailsLabel">Remark Details</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <div v-if="isLoadingRemarks" class="container">
                <div class="d-flex justify-content-center mt-5">
                  <loader></loader>
                </div>
              </div>
              <div v-else>
                <div v-if="this.tripRemarks.length > 0">
                  <table class="table table-bordered" id="remark-detail-table">
                    <thead>
                      <tr>
                        <th>SL</th>
                        <th>Remarks Type</th>
                        <th>Remark</th>
                        <th>Remark By</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(tripRemark, index) in tripRemarks"
                        :key="tripRemark.id"
                      >
                        <td>{{ ++index }}</td>
                        <td>{{ tripRemark.preset_remark_type }}</td>
                        <td>{{ tripRemark.remarks }}</td>
                        <td>{{ tripRemark.remarked_by }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else>
                  <p class="alert alert-danger">No Data Found 😢</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="conversionCreateModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="conversionCreateLabel">
              Add Call Details
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <form @submit.prevent="callDetailsFromSubmit">
                <div class="mb-3">
                  <label for="calledByInputField" class="form-label"
                    >Called By</label
                  >
                  <input
                    type="name"
                    class="form-control"
                    v-model="this.callDetailsFrom.called_by"
                    id="calledByInputField"
                    placeholder="Called By"
                  />
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Call Notes</label
                  >
                  <select
                    class="form-select"
                    aria-label="Default select example"
                    style="margin-right: 10px"
                    v-model="this.callDetailsFrom.call_notes_id"
                  >
                    <option value="">Select One</option>
                    <option
                      v-for="callNote in callNotes"
                      :key="callNote.id"
                      :value="callNote.id"
                    >
                      {{ callNote.call_note_type }}
                    </option>
                  </select>
                </div>
                <div class="modal-footer">
                  <button
                    type="submit"
                    id="callSubmitBtn"
                    class="btn btn-primary"
                    :class="{ disabled: talkedValidation }"
                    data-bs-dismiss="modal"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <teleport to="body">
    <!-- Modal -->
    <div
      class="modal fade"
      id="assignDriversToTripModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Assign Partner to the Trip
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <PartnerListAssignTrip
              :tripRequestId="tripRequest.id"
              @refreshInvitedPartners="getTripRequest"
            ></PartnerListAssignTrip>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="confirm-modal-show"
      :class="{ show: modalShow }"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ partnerStatus }} Partner
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Route:</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <input
                        type="text"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.route_name"
                      />
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.route_name }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Distance:</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <input
                        type="number"
                        min="0"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.distance"
                      />
                    </template>
                    <template v-else>
                      <p>
                        {{ Number(tripReqPartnerIdData.distance).toFixed(2) }}
                        km
                      </p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Total Price :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <input
                        type="text"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        @keyup="formatConfirmPrice(tripReqPartnerIdData.price)"
                        v-model="tripReqPartnerIdData.price"
                      />
                      <span class="text-muted d-none"
                        >one lakh three thousand six hundred fifty five</span
                      >
                    </template>
                    <template v-else>
                      <p>{{ formatPrice }} BDT</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Bonus :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <!--                      <input-->
                      <!--                        type='text'-->
                      <!--                        class='form-control form-control-plaintext p-1'-->
                      <!--                        :class='{ edit: isEditable }'-->
                      <!--                        @keyup='formatConfirmBonus(tripReqPartnerIdData.bonus)'-->
                      <!--                        v-model='tripReqPartnerIdData.bonus'-->
                      <!--                      />-->
                      <p v-if="tripReqPartnerIdData.bonus">
                        {{ tripReqPartnerIdData.bonus.split('.')[0] }} BDT
                      </p>
                      <p v-else>{{ sumBonusAmount }} BDT</p>
                    </template>
                    <template v-else>
                      <!--                      <p>-->
                      <!--                        {{-->
                      <!--                          // new Intl.NumberFormat('en-IN').format(-->
                      <!--                          //   tripReqPartnerIdData.bonus-->
                      <!--                          // )-->
                      <!--                        //  tripReqPartnerIdData.bonus ? tripReqPartnerIdData.bonus : sumBonusAmount-->
                      <!--                        }}-->
                      <!--                        BDT-->
                      <!--                      </p>-->

                      <p v-if="tripReqPartnerIdData.bonus != null">
                        {{ tripReqPartnerIdData.bonus.split('.')[0] }} BDT
                      </p>
                      <p v-else>{{ sumBonusAmount }} BDT</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Weekdays :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <!--                      <select-->
                      <!--                        class='form-select confirm-select'-->
                      <!--                        id='workingDays'-->
                      <!--                        aria-label='.form-select-lg example'-->
                      <!--                        :class='{ edit: isEditable }'-->
                      <!--                        v-model='formatWorkDays'-->
                      <!--                        @change='formatSelectData'-->
                      <!--                      >-->
                      <!--                        <option value='Sunday-Thursday(5 days)'>-->
                      <!--                          Sunday-Thursday (5 days)-->
                      <!--                        </option>-->
                      <!--                        <option value='Saturday-Thursday(6 days)'>-->
                      <!--                          Saturday-Thursday (6 days)-->
                      <!--                        </option>-->
                      <!--                      </select>-->
                      <Multiselect
                        v-model="this.workingDays"
                        mode="tags"
                        :searchable="true"
                        :createTag="true"
                        :closeOnSelect="false"
                        :resetAfter="true"
                        :options="weekDayNameOptions"
                        :clearOnSelect="true"
                        placeholder="Add week day"
                        @select="formatSelectData"
                        @deselect="formatSelectData"
                        @clear="removeElement"
                      />
                    </template>
                    <template v-else>
                      <p style="font-size: 13px">{{ formatWorkDays }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Home Pickup Time :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <!--                      <input-->
                      <!--                        type='time'-->
                      <!--                        class='form-control form-control-plaintext p-1'-->
                      <!--                        :class='{ edit: isEditable }'-->
                      <!--                        v-model='homePickUpTime'-->
                      <!--                        @change='changeHomeTime'-->
                      <!--                      />-->
                      <div
                        class="form-group"
                        v-for="(homePickUpInput, index) in homePickUpInputs"
                        :key="index"
                      >
                        <input
                          type="time"
                          class="form-control form-control-plaintext p-1"
                          :class="{ edit: isEditable }"
                          @change="formatSelectData"
                          placeholder="Enter Here"
                          v-model="homePickUpInput.homePickTimes"
                        /><span>
                          <i
                            class="bi bi-plus-square-fill"
                            @click="addHomePickUpTime(index), formatSelectData"
                            v-show="index == homePickUpInputs.length - 1"
                          >
                            Add</i
                          >
                          &nbsp;
                          <i
                            class="bi bi-dash-circle-fill"
                            @click="
                              removeHomePickUpTime(index), formatSelectData
                            "
                            v-show="
                              index || (!index && homePickUpInputs.length > 1)
                            "
                          >
                            Remove</i
                          >
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <p>{{ homePickUpTimeFormat }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Instruction for RM :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <textarea
                        cols="30"
                        rows="1"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.instruction_for_tm"
                      ></textarea>
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.instruction_for_tm }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Office Pickup Time :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <!--                      <input-->
                      <!--                        type='time'-->
                      <!--                        class='form-control form-control-plaintext p-1'-->
                      <!--                        :class='{ edit: isEditable }'-->
                      <!--                        v-model='officePickUpTime'-->
                      <!--                        @change='changeOfficeTime'-->
                      <!--                      />-->

                      <div
                        class="form-group"
                        v-for="(officePickUpInput, index) in officePickUpInputs"
                        :key="index"
                      >
                        <input
                          type="time"
                          class="form-control form-control-plaintext p-1"
                          :class="{ edit: isEditable }"
                          placeholder="Enter Here"
                          @change="formatSelectData()"
                          v-model="officePickUpInput.officePickTimes"
                        /><span>
                          <i
                            class="bi bi-plus-square-fill"
                            @click="
                              addOfficePickUpTime(index), formatSelectData()
                            "
                            v-show="index == officePickUpInputs.length - 1"
                          >
                            Add</i
                          >
                          &nbsp;
                          <i
                            class="bi bi-dash-circle-fill"
                            @click="
                              removeOfficePickUpTime(index), formatSelectData()
                            "
                            v-show="
                              index || (!index && officePickUpInputs.length > 1)
                            "
                          >
                            Remove</i
                          >
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <p>{{ officePickUpTimeFormat }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Instruction for Partner :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <textarea
                        cols="30"
                        rows="1"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.instruction_for_sp"
                      ></textarea>
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.instruction_for_sp }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Trip Type :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <select
                        v-model="selectedTripTypeName"
                        @change="selectedTripTypes"
                        class="form-select confirm-select"
                        :class="{ edit: isEditable }"
                      >
                        <template v-for="type in tripTypes" :key="type.id">
                          <option :value="type.name">
                            {{ type.name }}
                          </option>
                        </template>
                      </select>
                    </template>
                    <template v-else>
                      <p>{{ selectedTripTypeName }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <h6 class="">Pickup Points</h6>
              </div>
              <div class="col-12">
                <div class="row" :style="styleCal">
                  <template v-if="pickData.length === 2">
                    <div class="col-10">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 3">
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[2].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 4">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-4">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[3].name }}</p>
                    </div>
                  </template>
                  <template
                    v-else-if="pickData.length === 5"
                    style="width: 25%"
                  >
                    <div class="col">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[2].name }}</p>
                    </div>
                    <div class="col">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[3].name }}</p>
                    </div>
                    <div class="col">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[4].name }}</p>
                    </div>
                  </template>
                  <template v-else>
                    <template v-for="pick in pickData" :key="pick.name">
                      <div :class="calculateColPick">
                        <div class="contacts-row">
                          <div>
                            <i class="bi bi-record-circle-fill"></i>
                          </div>
                          <div class="dots"></div>
                        </div>
                        <p class="mt-0 p-0">{{ pick.name }}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h6>Drop Points</h6>
              </div>
              <div class="col-12">
                <div class="row" :style="styleCal">
                  <template v-if="dropData.length === 2">
                    <div class="col-10">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 3">
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[2].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 4">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-4">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[3].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 5">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[3].name }}</p>
                    </div>
                    <div class="col-1">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[4].name }}</p>
                    </div>
                  </template>
                  <template v-else>
                    <template v-for="drop in dropData" :key="drop.name">
                      <div :class="calculateColDrop">
                        <div class="contacts-row">
                          <div>
                            <i class="bi bi-geo-alt-fill"></i>
                          </div>
                          <div class="dots"></div>
                        </div>
                        <p class="mt-0 p-0">{{ drop.name }}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="confirm-modal">
              <button class="btn edit-info" @click="makeEditable">
                Edit Info
              </button>
              <button
                type="button"
                class="btn confirm-submit-button"
                data-bs-dismiss="modal"
                @click="confirmPartner"
              >
                {{ partnerStatus }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="contractDetailsModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Contract Details Edit
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Route:</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <input
                        type="text"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.route_name"
                      />
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.route_name }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Distance:</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <input
                        type="text"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.distance"
                        @keyup="calculateFarePrice"
                      />
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.distance }} km</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Total Price :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <input
                        type="text"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        @keyup="formatConfirmPrice(tripReqPartnerIdData.price)"
                        v-model="tripReqPartnerIdData.price"
                      />
                      <span class="text-muted d-none"
                        >one lakh three thousand six hundred fifty five</span
                      >
                    </template>
                    <template v-else>
                      <p>{{ formatPrice }} BDT</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Bonus :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <!--                      <input-->
                      <!--                        type='text'-->
                      <!--                        class='form-control form-control-plaintext p-1'-->
                      <!--                        :class='{ edit: isEditable }'-->
                      <!--                        @keyup='formatConfirmBonus(tripReqPartnerIdData.bonus)'-->
                      <!--                        v-model='tripReqPartnerIdData.bonus'-->
                      <!--                      />-->
                      <p v-if="tripReqPartnerIdData.bonus">
                        {{ tripReqPartnerIdData.bonus }} BDT
                      </p>
                      <p v-else>{{ sumBonusAmount }} BDT</p>
                    </template>
                    <template v-else>
                      <!--                      <p>-->
                      <!--                        {{-->
                      <!--                          // new Intl.NumberFormat('en-IN').format(-->
                      <!--                          //   tripReqPartnerIdData.bonus-->
                      <!--                          // )-->
                      <!--                          sumBonusAmount ? sumBonusAmount : tripReqPartnerIdData.bonus-->
                      <!--                        }}-->
                      <!--                        BDT-->
                      <!--                      </p>-->
                      <p v-if="tripReqPartnerIdData.bonus != null">
                        {{ tripReqPartnerIdData.bonus.split('.')[0] }} BDT
                      </p>
                      <p v-else>{{ sumBonusAmount }} BDT</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Weekdays :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <!--                      <select-->
                      <!--                        class='form-select confirm-select'-->
                      <!--                        aria-label='.form-select-lg example'-->
                      <!--                        :class='{ edit: isEditable }'-->
                      <!--                        v-model='formatWorkDays'-->
                      <!--                        @change='formatSelectData'-->
                      <!--                      >-->
                      <!--                        <option value='Sunday-Thursday(5 days)'>-->
                      <!--                          Sunday-Thursday (5 days)-->
                      <!--                        </option>-->
                      <!--                        <option value='Saturday-Thursday(6 days)'>-->
                      <!--                          Saturday-Thursday (6 days)-->
                      <!--                        </option>-->
                      <!--                      </select>-->
                      <Multiselect
                        v-model="this.workingDays"
                        mode="tags"
                        :searchable="true"
                        :createTag="true"
                        :closeOnSelect="false"
                        :resetAfter="true"
                        :options="weekDayNameOptions"
                        :clearOnSelect="true"
                        placeholder="Add week day"
                        @select="formatSelectData"
                        @deselect="formatSelectData"
                        @clear="removeElement"
                      />
                    </template>
                    <template v-else>
                      <div class="row">
                        <div class="col-sm text-break">
                          <p style="font-size: 13px">{{ formatWorkDays }}</p>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Home Pickup Time :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <div
                        class="form-group"
                        v-for="(homePickUpInput, index) in homePickUpInputs"
                        :key="index"
                      >
                        <input
                          type="time"
                          class="form-control form-control-plaintext p-1"
                          :class="{ edit: isEditable }"
                          placeholder="Enter Here"
                          v-model="homePickUpInput.homePickTimes"
                          @change="formatSelectData()"
                        /><span>
                          <i
                            class="bi bi-plus-square-fill"
                            @click="
                              addHomePickUpTime(index), formatSelectData()
                            "
                            v-show="index == homePickUpInputs.length - 1"
                          >
                            Add</i
                          >
                          &nbsp;
                          <i
                            class="bi bi-dash-circle-fill"
                            @click="
                              removeHomePickUpTime(index), formatSelectData()
                            "
                            v-show="
                              index || (!index && homePickUpInputs.length > 1)
                            "
                          >
                            Remove</i
                          >
                        </span>
                      </div>

                      <!--                        <input-->
                      <!--                          type='time'-->
                      <!--                          class='form-control form-control-plaintext p-1'-->
                      <!--                          :class='{ edit: isEditable }'-->
                      <!--                          v-model='homePickUpTime'-->
                      <!--                          @change='changeHomeTime'-->
                      <!--                        />-->
                    </template>
                    <template v-else>
                      <p>{{ homePickUpTimeFormat }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Instruction for RM :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <textarea
                        cols="30"
                        rows="1"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.instruction_for_tm"
                      ></textarea>
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.instruction_for_tm }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Office Pickup Time :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <!--                      <input-->
                      <!--                        type='time'-->
                      <!--                        class='form-control form-control-plaintext p-1'-->
                      <!--                        :class='{ edit: isEditable }'-->
                      <!--                        v-model='officePickUpTime'-->
                      <!--                        @change='changeOfficeTime'-->
                      <!--                      />-->
                      <div
                        class="form-group"
                        v-for="(officePickUpInput, index) in officePickUpInputs"
                        :key="index"
                      >
                        <input
                          type="time"
                          class="form-control form-control-plaintext p-1"
                          :class="{ edit: isEditable }"
                          placeholder="Enter Here"
                          @change="formatSelectData()"
                          v-model="officePickUpInput.officePickTimes"
                        /><span>
                          <i
                            class="bi bi-plus-square-fill"
                            @click="
                              addOfficePickUpTime(index), formatSelectData()
                            "
                            v-show="index == officePickUpInputs.length - 1"
                          >
                            Add</i
                          >
                          &nbsp;
                          <i
                            class="bi bi-dash-circle-fill"
                            @click="
                              removeOfficePickUpTime(index), formatSelectData()
                            "
                            v-show="
                              index || (!index && officePickUpInputs.length > 1)
                            "
                          >
                            Remove</i
                          >
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <p>{{ officePickUpTimeFormat }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-7">
                <div class="row">
                  <div class="col-6">
                    <h6>Instruction for Partner :</h6>
                  </div>
                  <div class="col-6 align-self-start">
                    <template v-if="isEditable">
                      <textarea
                        cols="30"
                        rows="1"
                        class="form-control form-control-plaintext p-1"
                        :class="{ edit: isEditable }"
                        v-model="tripReqPartnerIdData.instruction_for_sp"
                      ></textarea>
                    </template>
                    <template v-else>
                      <p>{{ tripReqPartnerIdData.instruction_for_sp }}</p>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row">
                  <div class="col-7">
                    <h6>Trip Type :</h6>
                  </div>
                  <div class="col-5">
                    <template v-if="isEditable">
                      <select
                        v-model="selectedTripTypeName"
                        @change="selectedTripTypes"
                        class="form-select confirm-select"
                        :class="{ edit: isEditable }"
                      >
                        <template v-for="type in tripTypes" :key="type.id">
                          <option :value="type.name">
                            {{ type.name }}
                          </option>
                        </template>
                      </select>
                    </template>
                    <template v-else>
                      <p>{{ selectedTripTypeName }}</p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <h6 class="">Pickup Points</h6>
              </div>
              <div class="col-12">
                <div class="row" :style="styleCal">
                  <template v-if="pickData.length === 2">
                    <div class="col-10">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 3">
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[2].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 4">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-4">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[3].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 5">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[3].name }}</p>
                    </div>
                    <div class="col-1">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ pickData[4].name }}</p>
                    </div>
                  </template>
                  <template v-else>
                    <template v-for="pick in pickData" :key="pick.name">
                      <div :class="calculateColPick">
                        <div class="contacts-row">
                          <div>
                            <i class="bi bi-record-circle-fill"></i>
                          </div>
                          <div class="dots"></div>
                        </div>
                        <p class="mt-0 p-0">{{ pick.name }}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h6>Drop Points</h6>
              </div>
              <div class="col-12">
                <div class="row" :style="styleCal">
                  <template v-if="dropData.length === 2">
                    <div class="col-10">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 3">
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[2].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 4">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-4">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[3].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 5">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[3].name }}</p>
                    </div>
                    <div class="col-1">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0">{{ dropData[4].name }}</p>
                    </div>
                  </template>
                  <template v-else>
                    <template v-for="drop in dropData" :key="drop.name">
                      <div :class="calculateColDrop">
                        <div class="contacts-row">
                          <div>
                            <i class="bi bi-geo-alt-fill"></i>
                          </div>
                          <div class="dots"></div>
                        </div>
                        <p class="mt-0 p-0">{{ drop.name }}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="confirm-modal">
              <button class="btn edit-info" @click="makeEditable">
                Edit Info
              </button>

              <!--              <button-->
              <!--                class='btn w-25 contract-button'-->
              <!--                data-bs-dismiss='modal'-->
              <!--                @submit.prevent='confirmPartner'-->
              <!--                :class="isContractFormDataValid ? '' : 'disabled'">-->
              <!--                Submit-->
              <!--              </button>-->
              <button
                class="btn w-25 contract-button"
                data-bs-dismiss="modal"
                @click="confirmPartner"
              >
                Submit
              </button>

              <!--              <button-->
              <!--                type="button"-->
              <!--                class="btn confirm-submit-button"-->
              <!--                data-bs-dismiss="modal"-->
              <!--                @click="confirmPartner"-->
              <!--              >-->
              <!--                Confirm Contact-->
              <!--              </button>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <!-- Modal -->
    <div
      class="modal fade"
      id="trSummaryEdit"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trSummaryEdit">Edit TR Summary</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit.prevent="updateTripSummary">
            <div class="modal-body">
              <div class="container col-md-12">
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label for="routeName" class="form-label"
                        >Route Name</label
                      >
                      <input
                        type="text"
                        v-model="editTrSummary.routeName"
                        class="form-control"
                        placeholder="Route Name"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <label for="tripStartDate" class="form-label"
                      >Trip Start Date</label
                    >
                    <Datepicker
                      v-model="editTrSummary.tripStartDate"
                      placeholder="Start Typing ..."
                      textInput
                      autoApply
                      required
                      :enableTimePicker="false"
                    />
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label for="routeName" class="form-label">Distance</label>
                      <input
                        type="text"
                        v-model="editTrSummary.tripDistance"
                        class="form-control"
                        placeholder="Distance"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label for="routeName" class="form-label"
                        >Price Per KM</label
                      >
                      <input
                        type="text"
                        v-model="editTrSummary.tripPerPrice"
                        class="form-control"
                        placeholder="Price Per KM"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col mb-3">
                    <label>Week day</label>
                    <Multiselect
                      v-model="editTrSummary.tripWeekDays"
                      mode="tags"
                      :searchable="true"
                      :createTag="true"
                      :closeOnSelect="false"
                      :resetAfter="true"
                      :options="weekDayNameOptions"
                      placeholder="Add week day"
                    />
                  </div>
                  <div class="col mb-3">
                    <label>Bonus Name</label>
                    <Multiselect
                      v-model="editTrSummary.tripBonusId"
                      mode="tags"
                      :searchable="true"
                      :createTag="true"
                      :closeOnSelect="false"
                      :resetAfter="true"
                      :options="bonusOptions"
                      @deselect="removeBonusId"
                      placeholder="Add bonus"
                    />
                  </div>
                  <div class="col mb-3" id="bonusType" style="display: none">
                    <label> Bonus Type</label>
                    <select
                      class="form-select"
                      @change="changeBonusTypes"
                      v-model="editTrSummary.tripBonusType"
                    >
                      <option value="flat">Flat</option>
                      <option value="percentage">percentage</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col"
                    id="completionBonusAmount"
                    style="display: none"
                  >
                    <div class="mb-3">
                      <label for="Completion Amount" class="form-label"
                        >Completion Amount</label
                      >
                      <input
                        type="text"
                        v-model="editTrSummary.completionAmount"
                        class="form-control"
                        placeholder="Completion Amount"
                      />
                    </div>
                  </div>
                  <div class="col" id="flatBonusAmount" style="display: none">
                    <div class="mb-3">
                      <label for="Flat Amount" class="form-label"
                        >Flat Amount</label
                      >
                      <input
                        type="text"
                        v-model="editTrSummary.flatAmount"
                        class="form-control"
                        placeholder="Flat Amount"
                      />
                    </div>
                  </div>

                  <div
                    class="col"
                    id="percentBonusAmount"
                    style="display: none"
                  >
                    <div class="mb-3">
                      <label for="Percent Amount" class="form-label"
                        >Percent Amount</label
                      >
                      <input
                        type="text"
                        v-model="editTrSummary.percentAmount"
                        class="form-control"
                        placeholder="Percent Amount"
                      />
                    </div>
                  </div>

                  <div class="col">
                    <div class="mb-3">
                      <label for="Route Type" class="form-label"
                        >Route Type</label
                      >
                      <input
                        type="text"
                        readonly
                        v-model="editTrSummary.routeType"
                        class="form-control"
                        placeholder="Trip Type"
                      />
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4 py-1">
                    <label for="tripType" class="form-label">Trip Type</label>
                    <Multiselect
                      v-model="editTrSummary.tripType"
                      :searchable="true"
                      :closeOnSelect="true"
                      :resetAfter="true"
                      :options="tripTypeOptions"
                      @change="emptyParentRoutes()"
                      placeholder="Add Trip Type"
                    />
                  </div>

                  <!-- Parent Route -->
                  <div
                    v-if="editTrSummary.tripType == this.serviceTypeId.B2C"
                    class="col-4 py-1"
                  >
                    <label for="parent_route_id" class="form-label"
                      >Parent Route</label
                    >
                    <Multiselect
                      v-model="editTrSummary.parent_route_id"
                      :closeOnSelect="true"
                      :searchable="true"
                      :options="parentRoutes"
                      :resetAfter="true"
                      placeholder="Select One"
                      @change="parentRouteNameHandler"
                    />
                  </div>

                  <!-- Dropdowns for B2B start -->
                  <div
                    v-if="editTrSummary.tripType == this.serviceTypeId.B2B"
                    class="col-4 py-1"
                  >
                    <label for="parent_route_id" class="form-label"
                      >Company Code</label
                    >
                    <Multiselect
                      v-model="editTrSummary.company_code"
                      :closeOnSelect="true"
                      :searchable="true"
                      :options="companyCodes"
                      :resetAfter="true"
                      placeholder="Select One"
                    />
                  </div>
                  <div
                    v-if="
                      editTrSummary.tripType == this.serviceTypeId.B2B &&
                      editTrSummary.company_code
                    "
                    class="col-4 py-1"
                  >
                    <label for="parent_route_id" class="form-label"
                      >Parent Route</label
                    >
                    <Multiselect
                      v-model="editTrSummary.parent_route_id"
                      :closeOnSelect="true"
                      :searchable="true"
                      :options="companyParentRoutes"
                      :resetAfter="true"
                      placeholder="Select One"
                      @change="companyParentRouteNameHandler"
                    />
                  </div>
                  <!-- Dropdowns for B2B end -->
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="mb-3"
                      v-for="(
                        editHomePickUpInput, index
                      ) in editHomePickUpInputs"
                      :key="index"
                    >
                      <label for="">Home pickup time</label>
                      <input
                        type="time"
                        class="form-control mt-2"
                        placeholder="Enter Here"
                        v-model="editHomePickUpInput.homePickTimes"
                      />
                      <span>
                        <i
                          class="bi bi-plus-square-fill"
                          @click="addEditTrHomePickUpTime(index)"
                          v-show="index == editHomePickUpInputs.length - 1"
                        >
                          Add</i
                        >
                        &nbsp;
                        <i
                          class="bi bi-dash-circle-fill"
                          @click="removeEditTrHomePickUpTime(index)"
                          v-show="
                            index || (!index && editHomePickUpInputs.length > 1)
                          "
                        >
                          Remove</i
                        >
                      </span>
                    </div>
                  </div>

                  <div class="col">
                    <div
                      class="mb-3"
                      v-for="(
                        editOfficePickUpInput, index
                      ) in editOfficePickUpInputs"
                      :key="index"
                    >
                      <label for="">Office pickup time</label>
                      <input
                        type="time"
                        class="form-control mt-2"
                        placeholder="Enter Here"
                        v-model="editOfficePickUpInput.officePickTimes"
                      />
                      <span>
                        <i
                          class="bi bi-plus-square-fill"
                          @click="addEditTrOfficePickUpTime(index)"
                          v-show="index == editOfficePickUpInputs.length - 1"
                        >
                          Add</i
                        >
                        &nbsp;
                        <i
                          class="bi bi-dash-circle-fill"
                          @click="removeEditTrOfficePickUpTime(index)"
                          v-show="
                            index ||
                            (!index && editOfficePickUpInputs.length > 1)
                          "
                        >
                          Remove</i
                        >
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label for="InstructionForPartner" class="form-label"
                        >Instruction For Partner</label
                      >
                      <textarea
                        class="form-control"
                        v-model="editTrSummary.tripInstructionPartner"
                        rows="2"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label for="InstructionForTM" class="form-label"
                        >Instruction For TM</label
                      >
                      <textarea
                        class="form-control"
                        v-model="editTrSummary.tripInstructionTM"
                        rows="2"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="mb-3" style="float: right">
                      <input
                        type="checkbox"
                        v-model="editTrSummary.change_all_cds"
                      />
                      Change all CDs also
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Save changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import Datepicker from 'vue3-date-time-picker';
import http from '../../config/axios';
// import httpUserService from '../../config/axiosUserService';
import userService from '../../config/axiosUserService.js';
import numberFormat from '../../helpers/formatNumber.js';
import numberInWord from '../../helpers/numberInWord.js';
import Loader from '../lib/Loader';
import Paginate from '../pagination/Pagination.vue';
import PartnerListAssignTrip from '../tripDetails/PartnerListAssignTrip.vue';

export default {
  name: 'DetailedTrip',
  props: ['alert', 'swal'],
  components: {
    Paginate,
    Loader,
    Multiselect,
    Datepicker,
    PartnerListAssignTrip
  },
  data() {
    return {
      collapseup: false,
      collapsedown: true,
      isCollapsable: false,
      tripRemarks: [],
      callDetailsFrom: {
        called_by: '',
        call_notes_id: ''
      },
      invitedPartnerList: [],
      opened: [],
      partnerDetails: [],
      countStats: '',
      tripRequest: {},
      pickUpTime: [],
      conversationLists: [],
      remarksForm: {
        tr_request_to_partner_id: '',
        preset_remark_id: '',
        remarks: '',
        remarked_by: ''
      },
      setRemarks: [],
      callNotes: [],
      isAssignOrConfirm: false,
      confirmed: [],
      isEditable: false,
      pickData: [],
      dropData: [],
      tripRequestModalData: [],
      tripTypes: [],
      selectedTripTypeName: '',
      partnerStatus: '',
      tripReqPartnerIdData: [],
      pickupData: [],
      dropoffData: [],
      timePick: [],
      totalPages: 0,
      total: 0,
      currentPage: 1,
      perPage: 0,
      isFilterOrNot: false,
      filterPartnerStatus: '',
      to: 0,
      from: 0,
      contractDetails: [],
      selectedContractId: '',
      selectedContractPId: '',
      contractFormData: {
        home: '',
        office: '',
        working_days: '',
        week_days: '',
        work_week_days: '',
        tripType: '',
        bonus: '',
        price: '',
        rm: '',
        sp: '',
        total_price: ''
      },
      global_search: '',
      isLoading: true,
      isLoadingCall: false,
      isLoadingRemarks: false,
      driverDetails: [],
      user_code: [],
      user_service: {
        name: '',
        mobile: null
      },
      tripRequestStatusCheck: {
        status: ''
      },
      modalShow: false,
      homePickTime: [],
      officePickTime: [],
      homePickUpInputs: [
        {
          homePickTimes: ''
        }
      ],
      officePickUpInputs: [
        {
          officePickTimes: ''
        }
      ],
      weekDayNameOptions: [
        { value: 'Saturday', label: 'Saturday' },
        { value: 'Sunday', label: 'Sunday' },
        { value: 'Monday', label: 'Monday' },
        { value: 'Tuesday', label: 'Tuesday' },
        { value: 'Wednesday', label: 'Wednesday' },
        { value: 'Thursday', label: 'Thursday' },
        { value: 'Friday', label: 'Friday' }
      ],
      workingDays: [],
      permission: '',
      editTrSummary: {
        routeName: '',
        tripType: '',
        tripDistance: '',
        tripPerPrice: '',
        tripWeekDays: [],
        tripBonusId: [],
        tripBonusType: '',
        completionAmount: '',
        flatAmount: '',
        percentAmount: '',
        routeType: '',
        tripInstructionPartner: '',
        tripInstructionTM: '',
        tripStartDate: '',
        parent_route_id: '',
        company_code: ''
      },
      editHomePickUpInputs: [
        {
          homePickTimes: ''
        }
      ],
      editOfficePickUpInputs: [
        {
          officePickTimes: ''
        }
      ],
      tripTypeOptions: [],
      bonusOptions: [],
      bonusTypeOptions: ['Flat', 'percentage'],
      parentRoutes: [],
      companyCodes: [],
      companyParentRoutes: [],
      serviceTypeId: {}
    };
  },
  created() {
    this.getTripTypes();
  },
  mounted() {
    this.getTripRequest();
    this.getCallNotesList();
    // this.searchData();
    // this.getDriverDetails();
    http
      .get('v2/partners/remarks/presets')
      .then((response) => (this.setRemarks = response.data.data))
      .catch((error) => {
        console.error('Error', error);
      });
    this.permission = localStorage.getItem('userPermission').split(',');
    this.getBonusList();

    this.loadParenRoutes();
    this.loadCompanyCodes();
  },
  watch: {
    filterValues: {
      handler: 'pickDisplay'
    },
    user_service: {
      handler: function () {
        this.searchData();
      }
    },
    'editTrSummary.tripBonusId': {
      handler: function (value) {
        var bonusType = document.getElementById('bonusType');
        var completionAmount = document.getElementById('completionBonusAmount');
        var flatAmount = document.getElementById('flatBonusAmount');
        var percentAmount = document.getElementById('percentBonusAmount');

        value.forEach((data) => {
          let isFound = this.bonusOptions.find(
            (object) => object.value === data
          );
          if (isFound && isFound.label === 'Shuttle Bonus') {
            bonusType.style.display = 'block';
          }

          if (isFound && isFound.label === 'Completion Bonus') {
            completionAmount.style.display = 'block';
          }
        });

        // if (this.editTrSummary.tripBonusId > 0){
        //
        // }

        if (this.editTrSummary.tripBonusId == 0) {
          bonusType.style.display = 'none';
          completionAmount.style.display = 'none';
          flatAmount.style.display = 'none';
          percentAmount.style.display = 'none';
        }
      },
      deep: true
    },
    // 'editTrSummary.tripBonusType': {
    //   handler: function() {
    //     var flatAmount = document.getElementById('flatBonusAmount');
    //     var percentAmount = document.getElementById('percentBonusAmount');
    //     if (this.editTrSummary.tripBonusType === 'Flat') {
    //       flatAmount.style.display = 'block';
    //     }
    //     if (this.editTrSummary.tripBonusType === 'percentage') {
    //       percentAmount.style.display = 'block';
    //     }
    //   },
    //   deep: true
    // },
    editHomePickUpInputs: {
      handler: function () {
        this.syncRouteType();
        // value.forEach((value) => {
        //   if (
        //     value.homePickTimes != '' &&
        //     this.editOfficePickUpInputs.length === 0
        //   ) {
        //     this.editTrSummary.routeType = 'One way';
        //   }
        //   if (
        //     value.homePickTimes === '' &&
        //     this.editOfficePickUpInputs.length != 0
        //   ) {
        //     this.editTrSummary.routeType = 'One way';
        //   }
        // });
      },
      deep: true
    },
    editOfficePickUpInputs: {
      handler: function () {
        this.syncRouteType();
        // value.forEach((data) => {
        //   if (
        //     data.officePickTimes === '' &&
        //     this.editHomePickUpInputs.length != 0
        //   ) {
        //     this.editTrSummary.routeType = 'One way';
        //   }
        //   if (
        //     data.officePickTimes != '' &&
        //     this.editHomePickUpInputs.length != 0
        //   ) {
        //     this.editTrSummary.routeType = 'Both way';
        //   }
        // });
      },
      deep: true
    },
    'editTrSummary.company_code': {
      handler: function () {
        this.loadCompanyParentRoutes(this.editTrSummary.company_code);
      },
      deep: true
    }
  },
  methods: {
    syncRouteType() {
      let homePickTime = false;
      let officePickTime = false;

      this.editHomePickUpInputs.forEach((element) => {
        if (element.homePickTimes) {
          homePickTime = true;
        }
      });

      this.editOfficePickUpInputs.forEach((element) => {
        if (element.officePickTimes) {
          officePickTime = true;
        }
      });

      if (homePickTime && officePickTime) {
        this.editTrSummary.routeType = 'Both way';
      } else {
        this.editTrSummary.routeType = 'One way';
      }
    },

    loadParenRoutes() {
      http.get('v2/parent/routes').then((response) => {
        let parentRoutesData = response.data.data;
        parentRoutesData.forEach((object) => {
          this.parentRoutes.push({
            value: object.parent_route_id,
            label: object.name
          });
        });
      });
    },

    loadCompanyCodes() {
      http.get('v2/company/lists').then((response) => {
        let companyCodeData = response.data.data.data;
        companyCodeData.forEach((object) => {
          this.companyCodes.push({
            value: object.companyCode,
            label: object.name
          });
        });
      });
    },

    loadCompanyParentRoutes(value) {
      http.get(`v2/routes/by/compnay?companyCode=${value}`).then((response) => {
        let parentRoutesData = response.data.data.data;
        this.companyParentRoutes = [];
        parentRoutesData.forEach((object) => {
          this.companyParentRoutes.push({
            value: object.id,
            label: object.name
          });
        });
      });
    },

    emptyParentRoutes() {
      this.editTrSummary.company_code = '';
      this.editTrSummary.parent_route_id = '';
    },

    changeBonusTypes(e) {
      let value = e.target.value;

      let flatBonusAmount = document.getElementById('flatBonusAmount');
      let percentBonusAmount = document.getElementById('percentBonusAmount');

      if (value === 'percentage') {
        percentBonusAmount.style.display = 'block';
      } else {
        percentBonusAmount.style.display = 'none';
      }
      if (value === 'flat') {
        flatBonusAmount.style.display = 'block';
      } else {
        flatBonusAmount.style.display = 'none';
      }
    },
    editFormatHomeTime() {
      let timeArray = [];
      this.editHomePickUpInputs.forEach((value) => {
        if (value.homePickTimes.length) {
          let time = value.homePickTimes;
          let [hours, minutes] = time.split(':');
          let ampm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12;
          hours = hours ? hours : 12;
          let format = `${hours}:${minutes} ${ampm}`;

          timeArray.push({
            time: format,
            type: 'HomePickUp'
          });
        }
      });
      return timeArray;
    },
    editFormatOfficeTime() {
      let timeArray = [];
      this.editOfficePickUpInputs.forEach((value) => {
        if (value.officePickTimes.length) {
          let time = value.officePickTimes;
          let [hours, minutes] = time.split(':');
          let ampm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12;
          hours = hours ? hours : 12;
          let format = `${hours}:${minutes} ${ampm}`;

          timeArray.push({
            time: format,
            type: 'OfficePickUp'
          });
        }
      });
      return timeArray;
    },

    // makeOwner(driverInfo) {
    //   this.$swal({
    //     title: 'Are you sure?',
    //     text: `You are making ${driverInfo.name} an Owner!`,
    //     icon: 'warning',
    //     type: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes, Sure!'
    //   }).then((result) => {
    //     if (result.value) {
    //       httpUserService
    //         .post(`/v1/users/attach-linked-user`, {
    //           user_code: driverInfo.user_code,
    //           role: 'Driver',
    //           linked_user_code: driverInfo.user_code,
    //           linked_user_role: 'Owner',
    //           system: 'Partner App'
    //         })
    //         .then(
    //           (response) => {
    //             if (response.status === 200) {
    //               this.$swal({
    //                 icon: 'success',
    //                 title: 'Congratulations!',
    //                 text: response.data.message
    //               });
    //             }
    //           },
    //           (error) => {
    //             console.log(error);
    //             this.$swal({
    //               icon: 'error',
    //               title: 'Sorry!',
    //               text: 'Something went wrong!'
    //             });
    //           }
    //         );
    //     }
    //   });
    // },

    updateTripSummary() {
      var pickupFormattedTime = [
        this.editFormatHomeTime(),
        this.editFormatOfficeTime()
      ];

      var bonusArray = this.editTrSummary.tripBonusId.map((bonusObject) => {
        if (
          this.bonusOptions.find((data) => data.value == bonusObject).label ===
            'Shuttle Bonus' &&
          this.editTrSummary.tripBonusType === 'flat'
        ) {
          this.editTrSummary.percentAmount = '';
          return {
            bonus_id: this.bonusOptions.find(
              (data) => data.value == bonusObject
            ).value,
            type: this.editTrSummary.tripBonusType,
            base_bonus: this.editTrSummary.flatAmount
          };
        }
        if (
          this.bonusOptions.find((data) => data.value == bonusObject).label ===
            'Shuttle Bonus' &&
          this.editTrSummary.tripBonusType === 'percentage'
        ) {
          this.editTrSummary.flatAmount = '';
          return {
            bonus_id: this.bonusOptions.find(
              (data) => data.value == bonusObject
            ).value,
            type: this.editTrSummary.tripBonusType,
            base_bonus: this.editTrSummary.percentAmount
          };
        }

        if (
          this.bonusOptions.find((data) => data.value == bonusObject).label ===
          'Completion Bonus'
        ) {
          return {
            bonus_id: this.bonusOptions.find(
              (data) => data.value == bonusObject
            ).value,
            type: 'flat',
            base_bonus: this.editTrSummary.completionAmount
          };
        }
      });

      let parentRouteName = '';
      if (
        this.editTrSummary.company_code &&
        this.editTrSummary.parent_route_id
      ) {
        this.companyParentRoutes.forEach((item) => {
          if (item.value == this.editTrSummary.parent_route_id) {
            parentRouteName = item.label;
          }
        });
      } else if (this.editTrSummary.parent_route_id) {
        this.parentRoutes.forEach((item) => {
          if (item.value == this.editTrSummary.parent_route_id) {
            parentRouteName = item.label;
          }
        });
      }

      let dataObject = {
        instruction_for_sp: this.editTrSummary.tripInstructionPartner,
        instruction_for_tm: this.editTrSummary.tripInstructionTM,
        trip_per_price: this.editTrSummary.tripPerPrice,
        trip_start_date: this.editTrSummary.tripStartDate,
        trip_types_id: this.editTrSummary.tripType,
        week_days: Object.values(this.editTrSummary.tripWeekDays).toString(),
        working_days: this.editTrSummary.tripWeekDays.length,
        route_type: this.editTrSummary.routeType,
        pickUpTime: pickupFormattedTime.flat(),
        bonus: bonusArray,
        distance: this.editTrSummary.tripDistance,
        route_name: this.editTrSummary.routeName,
        parent_route_id: this.editTrSummary.parent_route_id,
        parent_route_name: parentRouteName,
        company_code: this.editTrSummary.company_code
      };

      if (this.editTrSummary.change_all_cds) {
        dataObject.change_all_cds = this.editTrSummary.change_all_cds;
      }

      http
        .patch(`/v2/partners/triprequests/${this.$route.params.id}`, dataObject)
        .then(
          (response) => {
            if (response.status === 200) {
              // location.reload();
              this.getTripRequest();
            }
          },
          (error) => {
            console.log(error);
          }
        );
    },
    removeBonusId(value) {
      let found = this.bonusOptions.find((data) => data.value === value);
      let completionBonusAmount = document.getElementById(
        'completionBonusAmount'
      );
      let bonusType = document.getElementById('bonusType');
      let flatBonusAmount = document.getElementById('flatBonusAmount');
      let percentBonusAmount = document.getElementById('percentBonusAmount');

      if (found.label === 'Completion Bonus') {
        completionBonusAmount.style.display = 'none';
      } else {
        bonusType.style.display = 'none';
        percentBonusAmount.style.display = 'none';
        flatBonusAmount.style.display = 'none';
      }
    },
    getAllTrSummaryData() {
      var flatAmount = document.getElementById('flatBonusAmount');
      var percentAmount = document.getElementById('percentBonusAmount');
      var completionBonusAmount = document.getElementById(
        'completionBonusAmount'
      );

      this.editTrSummary.routeName = this.tripRequest.route_name;
      this.editTrSummary.tripType = null;
      for (const item of this.tripTypeOptions) {
        if (item.label === this.tripRequest.tripType) {
          this.editTrSummary.tripType = item.value;
          break;
        }
      }
      this.editTrSummary.tripDistance = this.tripRequest.distance;
      this.editTrSummary.tripPerPrice = this.tripRequest.trip_per_price;
      this.editTrSummary.tripWeekDays = this.tripRequest?.week_days.split(',');
      this.editTrSummary.company_code = this.tripRequest.company_code
        ? this.tripRequest.company_code
        : null;
      this.editTrSummary.parent_route_id = this.tripRequest.parent_route_id;
      this.editTrSummary.change_all_cds = false;
      this.editTrSummary.routeType = this.tripRequest.route_type
        ? this.tripRequest.route_type
        : null;
      this.editTrSummary.tripBonusId = [];
      this.tripRequest?.trip_request_bonus.forEach((data) => {
        this.editTrSummary.tripBonusId.push(data.bonus_id);
        if (data.bonus.bonus_name === 'Shuttle Bonus' && data.type === 'flat') {
          flatAmount.style.display = 'block';
          this.editTrSummary.tripBonusType = data.type;
          this.editTrSummary.flatAmount = data.base_bonus;
        }
        if (
          data.bonus.bonus_name === 'Shuttle Bonus' &&
          data.type === 'percentage'
        ) {
          percentAmount.style.display = 'block';
          this.editTrSummary.tripBonusType = data.type;
          this.editTrSummary.percentAmount = data.base_bonus;
        }
        if (data.bonus.bonus_name === 'Completion Bonus') {
          completionBonusAmount.style.display = 'block';
          this.editTrSummary.completionAmount = data.base_bonus;
        }
      });

      let pickTimeFilter = this.homePickTime.filter(function (item) {
        return item.type == 'HomePickUp';
      });

      if (pickTimeFilter.length != 0) {
        this.editHomePickUpInputs.length = 0;
        for (let i = 0; i < pickTimeFilter.length; i++) {
          let d = new Date('2000-01-01 ' + pickTimeFilter[i].time);
          let hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
          let minutes =
            d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
          this.editHomePickUpInputs.push({
            homePickTimes: `${hour}:${minutes}`
          });
        }
      }

      let officeTimeFilter = this.officePickTime.filter(function (item) {
        return item.type == 'OfficePickUp';
      });

      if (officeTimeFilter.length != 0) {
        this.editOfficePickUpInputs.length = 0;
        for (let i = 0; i < officeTimeFilter.length; i++) {
          let d = new Date('2000-01-01 ' + officeTimeFilter[i].time);
          let hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
          let minutes =
            d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
          this.editOfficePickUpInputs.push({
            officePickTimes: `${hour}:${minutes}`
          });
        }
      }

      //this.editTrSummary.routeType = this.tripRequest.route_type;

      this.editTrSummary.tripInstructionTM =
        this.tripRequest.instruction_for_tm;
      this.editTrSummary.tripInstructionPartner =
        this.tripRequest.instruction_for_sp;
      this.editTrSummary.tripStartDate = this.tripRequest.trip_start_date;
    },
    getBonusList() {
      http.get('/v2/partners/bonus').then(
        (response) => {
          let bonusResponse = response.data.data;
          bonusResponse.forEach((object) => {
            this.bonusOptions.push({
              value: object.id,
              label: object.bonus_name
            });
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
    formatHomeTime() {
      let timeArray = [];
      this.homePickUpInputs.forEach((value) => {
        if (value.homePickTimes.length) {
          let time = value.homePickTimes;
          let [hours, minutes] = time.split(':');
          let ampm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12;
          hours = hours ? hours : 12;
          let format = `${hours}:${minutes} ${ampm}`;

          timeArray.push({
            time: format,
            type: 'HomePickUp'
          });
        }
      });
      return timeArray;
    },
    formatOfficeTime() {
      let timeArray = [];
      this.officePickUpInputs.forEach((value) => {
        if (value.officePickTimes.length) {
          let time = value.officePickTimes;
          let [hours, minutes] = time.split(':');
          let ampm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12;
          hours = hours ? hours : 12;
          let format = `${hours}:${minutes} ${ampm}`;

          timeArray.push({
            time: format,
            type: 'OfficePickUp'
          });
        }
      });
      return timeArray;
    },

    addOfficePickUpTime() {
      this.officePickUpInputs.push({
        officePickTimes: ''
      });
    },
    addEditTrOfficePickUpTime() {
      this.editOfficePickUpInputs.push({
        officePickTimes: ''
      });
    },
    removeEditTrOfficePickUpTime(index) {
      this.editOfficePickUpInputs.splice(index, 1);
    },
    removeOfficePickUpTime(index) {
      this.officePickUpInputs.splice(index, 1);
      this.formatSelectData();
    },
    addHomePickUpTime() {
      this.homePickUpInputs.push({
        homePickTimes: ''
      });
    },
    addEditTrHomePickUpTime() {
      this.editHomePickUpInputs.push({
        homePickTimes: ''
      });
    },
    removeEditTrHomePickUpTime(index) {
      this.editHomePickUpInputs.splice(index, 1);
    },
    removeHomePickUpTime(index) {
      this.homePickUpInputs.splice(index, 1);
      this.formatSelectData();
    },
    closeModal() {
      this.modalShow = false;
      document.getElementById('confirm-modal-show').style.display = 'none';
    },
    getTripRequest(value) {
      http
        .get(
          `v2/partners/triprequests/${this.$route.params.id}` +
            '?global_search=' +
            this.global_search +
            '&page=' +
            value +
            '&user_code=' +
            this.user_code +
            '&requestFromWeb=' +
            true
        )
        .then((response) => {
          this.invitedPartnerList = response.data.data.invitedPartnerList.data;
          // this.isLoading = false;
          this.partnerDetails = response.data.data;
          this.countStats = response.data.data.countStats[0];
          this.tripRequest = response.data.data.tripRequest[0];
          this.tripRequestModalData = response.data.data.tripRequest[0];
          this.tripRequestModalData.pickUpTime = this.pickUpTime;
          this.tripRequestModalData.points = this.pickData.concat(
            this.dropData
          );
          this.pickupData = response.data.data.points.filter(
            (point) => point.type === 'PickUp'
          );
          this.dropoffData = response.data.data.points.filter(
            (point) => point.type === 'DropOff'
          );
          this.timePick = response.data.data.pickUpTime;

          this.homePickTime = this.timePick.filter(
            (homePick) => homePick.type === 'HomePickUp'
          );

          this.officePickTime = this.timePick.filter(
            (officePick) => officePick.type === 'OfficePickUp'
          );

          this.getDriverDetails(
            response.data.data.invitedPartnerList.data.map(
              (user) => user.partner_id
            )
          );
          this.total = response.data.data.invitedPartnerList.total;
          this.totalPages = response.data.data.invitedPartnerList.last_page;
          this.currentPage = response.data.data.invitedPartnerList.current_page;
          this.perPage = response.data.data.invitedPartnerList.per_page;
          this.to = response.data.data.invitedPartnerList.to;
          this.from = response.data.data.invitedPartnerList.from;
        })
        .catch((error) => {
          console.error('Error', error);
        });
    },
    getTripTypes() {
      http.get('v2/trips/types').then((res) => {
        this.tripTypes = res.data.data;
        this.tripTypes.forEach((object) => {
          this.tripTypeOptions.push({
            value: object.id,
            label: object.name
          });
        });
        this.tripTypes.forEach((ele) => {
          this.serviceTypeId[ele.name] = ele.id;
        });
      });
    },
    filtering(page) {
      if (this.filterPartnerStatus) {
        this.isFilterOrNot = true;
      } else {
        this.isFilterOrNot = false;
      }
      this.isLoading = true;
      let options = {
        url: `v2/partners/triprequests/invitations/status?page=${page}`,
        data: {
          status: this.filterPartnerStatus,
          trip_request_id: `${this.$route.params.id}`,
          global_search: this.global_search
        },
        method: 'POST'
      };
      http(options).then((response) => {
        this.invitedPartnerList = response.data.data.data;
        this.total = response.data.data.total;
        this.totalPages = response.data.data.last_page;
        this.currentPage = response.data.data.current_page;
        this.perPage = response.data.data.per_page;
        this.to = response.data.data.to;
        this.from = response.data.data.from;
        this.isLoading = false;
      });
    },
    partnerListFilter() {
      this.filtering();
    },
    collapseUp() {
      this.collapseup = false;
      this.collapsedown = true;
      var statusdisplay = document.getElementById('blockDisplay');
      statusdisplay.style.display = 'flex';
    },

    collapseDown() {
      this.collapsedown = false;
      this.collapseup = true;
      var statusdisplay = document.getElementById('blockDisplay');
      statusdisplay.style.display = 'none';
    },
    callDetailsFromSubmit() {
      let pId = window.localStorage.getItem('talkedPid');
      let id = window.localStorage.getItem('talkedId');

      http
        .post('v2/partners/calls/details', {
          partner_id: pId,
          called_by: this.callDetailsFrom.called_by,
          tr_request_to_partner_id: id,
          call_notes_id: this.callDetailsFrom.call_notes_id
        })
        .then((response) => {
          if (response.status == 200) {
            this.alert({
              title: 'Call Details!',
              text: 'Call details created successfully',
              icon: 'success',
              button: 'Aww yiss!'
            });
            this.getTripRequest();
            location.reload();
            window.localStorage.removeItem('talkedPid');
            window.localStorage.removeItem('talkedId');
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getRemarksList(id) {
      this.isLoadingRemarks = true;
      http
        .get('v2/partners/remarks/' + id)
        .then((response) => {
          this.tripRemarks = response.data.data;
          this.isLoadingRemarks = false;
        })
        .catch((error) => {
          console.error('There was an error!', error);
        });
    },
    checkVisibility(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(id);
      }
    },

    viewCall(id) {
      this.isLoadingCall = true;
      http
        .get('v2/partners/calls/details/' + id)
        .then((response) => {
          this.conversationLists = response.data.data;
          this.isLoadingCall = false;
        })
        .catch((error) => {
          console.error('Error', error);
        });
    },
    createNewRemarks(id) {
      window.localStorage.setItem('tripRequestToPartnerId', id);
      this.remarksForm.preset_remark_id = '';
      this.remarksForm.remarks = '';
      this.remarksForm.remarked_by = '';
    },
    submitRemark() {
      http
        .post('v2/partners/remarks', {
          tr_request_to_partner_id: window.localStorage.getItem(
            'tripRequestToPartnerId'
          ),
          preset_remark_id: this.remarksForm.preset_remark_id,
          remarks: this.remarksForm.remarks,
          remarked_by: this.remarksForm.remarked_by
        })
        .then((response) => {
          if (response.status == '200') {
            this.alert({
              title: 'Remarks!',
              text: 'Remarks created successfully',
              icon: 'success',
              button: 'Aww yiss!'
            });
            this.getTripRequest();
            window.localStorage.removeItem('tripRequestToPartnerId');
            location.reload();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    confirmButton(partnerId, id) {
      this.tripPartnerById(id);
      this.isEditable = false;
      // localStorage.removeItem('contractDetailStatus');
      window.localStorage.setItem('pId', partnerId);
      window.localStorage.setItem('id', id);
      this.invitedPartnerStatus();
      const index = this.confirmed.indexOf(partnerId);
      if (index > -1) {
        this.confirmed.splice(index, 1);
      } else {
        this.confirmed.push(partnerId);
      }
    },
    confirmUnassignedButton(partner_id, id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to change the status of this trip?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, change it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          http
            .put(
              'v2/partners/triprequests/invitations/' +
                partner_id +
                '?trip_request_to_partner_id=' +
                id +
                '&status=' +
                'Unassigned'
            )
            .then((response) => {
              if (response.status == '200') {
                this.getTripRequest();
              }
            })
            .catch((error) => {
              console.log(error);
              this.errored = true;
            });
        }
      });
    },

    checkAssignedDriveToTrip(partner_id, id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to change the status of this trip?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, change it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          http
            .put(
              'v2/partners/triprequests/invitations/' +
                partner_id +
                '?trip_request_to_partner_id=' +
                id +
                '&status=' +
                'Assigned'
            )
            .then((response) => {
              if (response.status == '200') {
                this.getTripRequest();
              }
            })
            .catch((error) => {
              console.log(error);
              this.errored = true;
            });
        }
      });
    },
    confirmReSendSms(partner_id, mobile) {
      const dataObject = {
        trip_request_id: this.$route.params.id,
        partner_id: [partner_id],
        mobile: [mobile],
        resend: 'yes'
      };

      http
        .post('v2/partners/triprequests/invitations', dataObject)
        .then((response) => {
          if (response.status === 200) {
            this.$swal('Submit!', 'Your sms has been sent.', 'success');
            // this.getTripRequest();
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    removeElement() {
      (this.workingDays = []), this.formatSelectData();
    },
    formatSelectData() {
      let workDays = this.workingDays;
      // let splitWeekDays = workDays;
      let week_days = workDays.join(',');
      let working_days = this.workingDays.length;

      let officeCount = 0;
      let homeCount = 0;

      this.homePickUpInputs.forEach((value) => {
        if (value.homePickTimes != false) {
          homeCount++;
        }
      });

      this.officePickUpInputs.forEach((value) => {
        if (value.officePickTimes != false) {
          officeCount++;
        }
      });

      let homePickTimeLength = homeCount;
      let officePickTimeLength = officeCount;

      this.tripReqPartnerIdData.working_days = +working_days;
      this.tripReqPartnerIdData.week_days = week_days;

      this.tripReqPartnerIdData.price = Math.round(
        (homePickTimeLength + officePickTimeLength) *
          Number(this.tripReqPartnerIdData.trip_per_price) *
          this.tripReqPartnerIdData.distance *
          Number(working_days)
      );

      this.tripReqPartnerIdData.price = numberFormat(
        this.tripReqPartnerIdData.price
      );
    },
    makeEditable() {
      this.isEditable = true;
      this.tripReqPartnerIdData.price = this.tripReqPartnerIdData.price.replace(
        /,/g,
        ''
      );
      this.tripReqPartnerIdData.price =
        this.tripReqPartnerIdData.price.split('.')[0];
      this.tripReqPartnerIdData.price = numberFormat(
        this.tripReqPartnerIdData.price
      );

      // var calculateOtherBonus = this.contractDetails.tripRequestBonus?.map((item) => {
      //   return item.base_bonus;
      // }).reduce((cur, prev) => cur + prev, 0);

      this.tripReqPartnerIdData.bonus = this.tripReqPartnerIdData
        ? this.tripReqPartnerIdData.bonus
        : this.tripReqPartnerIdData.bonus.replace(/,/g, '');

      this.tripReqPartnerIdData.bonus =
        this.tripReqPartnerIdData.bonus != null
          ? this.tripReqPartnerIdData.bonus.split('.')[0]
          : null;

      // this.tripReqPartnerIdData.bonus = numberFormat(
      //   this.tripReqPartnerIdData.bonus
      // );

      // this.tripReqPartnerIdData.distance =
      //   this.tripReqPartnerIdData.distance.split('.')[0];

      // this.tripReqPartnerIdData.distance = Number(this.tripReqPartnerIdData.distance).toFixed(2);
      this.tripReqPartnerIdData.distance = Number(
        this.tripReqPartnerIdData.distance
      ).toFixed(2);

      let pickTimeFilter = this.pickUpTime.filter(function (item) {
        return item.type == 'HomePickUp';
      });

      if (pickTimeFilter.length != 0) {
        this.homePickUpInputs.length = 0;
        for (let i = 0; i < pickTimeFilter.length; i++) {
          let d = new Date('2000-01-01 ' + pickTimeFilter[i].time);
          let hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
          let minutes =
            d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
          this.homePickUpInputs.push({ homePickTimes: `${hour}:${minutes}` });
        }
      }

      let officeTimeFilter = this.pickUpTime.filter(function (item) {
        return item.type == 'OfficePickUp';
      });

      if (officeTimeFilter.length != 0) {
        this.officePickUpInputs.length = 0;
        for (let i = 0; i < officeTimeFilter.length; i++) {
          // let [h, m] = officeTimeFilter[i].time.split(':');
          // let min = m.split(' ')[0];
          // let d = new Date(Date.UTC(2022, 2, 2, +h + 6, min));
          // let hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
          // let minutes = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
          // this.officePickUpInputs.push({ officePickTimes: `${hour}:${minutes}` });
          let d = new Date('2000-01-01 ' + officeTimeFilter[i].time);
          let hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
          let minutes =
            d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
          this.officePickUpInputs.push({
            officePickTimes: `${hour}:${minutes}`
          });
        }
      }

      this.workingDays = [];
      let getWeekDay = this.tripReqPartnerIdData.week_days;

      getWeekDay.split(',').forEach((value) => {
        this.workingDays.push(value);
      });
    },
    confirmPartner() {
      let partnerId = window.localStorage.getItem('pId');
      let id = window.localStorage.getItem('id');
      let tripType = this.tripTypes.filter(
        (tripType) => tripType.name === this.selectedTripTypeName
      );

      let getPartnerById = this.invitedPartnerList.find((ipl) => ipl.id == id);

      let partnerStatus = '';

      if (!localStorage.getItem('contractDetailStatus')) {
        if (getPartnerById.status == 'Interested') {
          partnerStatus = 'Confirmed';
        }
        if (getPartnerById.status == 'Confirmed') {
          partnerStatus = 'Accepted';
          // partnerStatus = 'Assigned';
        }
        if (getPartnerById.status == 'Accepted') {
          partnerStatus = 'Assigned';
        }
      } else {
        localStorage.removeItem('contractDetailStatus');
        partnerStatus = getPartnerById.status;
      }
      let pickup_time = [this.formatHomeTime(), this.formatOfficeTime()];

      let partnerData = {
        distance: this.tripReqPartnerIdData.distance,
        route_name: this.tripReqPartnerIdData.route_name,
        trip_request_to_partner_id: id,
        // bonus: this.tripReqPartnerIdData.bonus.split(',').join(''),
        price: this.tripReqPartnerIdData.price.split(',').join(''),
        working_days: this.tripReqPartnerIdData.working_days,
        week_days: this.tripReqPartnerIdData.week_days,
        tripType: tripType[0].id,
        instruction_for_tm: this.tripReqPartnerIdData.instruction_for_tm,
        instruction_for_sp: this.tripReqPartnerIdData.instruction_for_sp,
        status: partnerStatus,
        // pickUpTime: [...this.pickUpTime]
        pickUpTime: pickup_time.flat()
        // points: [...this.pickData.concat(this.dropData)]
      };

      http
        .put(`v2/partners/triprequests/invitations/${partnerId}`, partnerData)
        .then((response) => {
          if (response.status === 200) {
            this.getTripRequest();
            this.isEditable = false;
            this.modalShow = false;
            document
              .getElementById('confirm-modal-show')
              .classList.remove('show');
            document
              .getElementById('confirm-modal-show')
              .removeAttribute('style');
            location.reload();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    createNewTalkTalked(id, pId) {
      window.localStorage.setItem('talkedId', id);
      window.localStorage.setItem('talkedPid', pId);
      this.callDetailsFrom.call_notes_id = '';
      this.callDetailsFrom.called_by = '';
    },
    getCallNotesList() {
      http
        .get('v2/partners/calls/notes')
        .then((response) => {
          this.callNotes = response.data.data;
        })
        .catch((error) => {
          console.error('Error', error);
        });
    },

    changeHomeTime(e) {
      this.pickUpTime[0].time = e.target.value;
    },
    changeOfficeTime(e) {
      this.pickUpTime[1].time = e.target.value;
    },
    selectedTripTypes(e) {
      this.selectedTripTypeName = e.target.value;
    },
    invitedPartnerStatus() {
      let status = '';
      let id = JSON.parse(window.localStorage.getItem('id'));
      let partner = this.invitedPartnerList.filter((ipl) => {
        return ipl.id == id;
      });
      if (partner.length > 0) {
        if (partner[0].status === 'Interested') {
          status = 'Confirm';
        } else if (partner[0].status === 'Confirmed') {
          status = 'Accepted';
        } else if (partner[0].status === 'Accepted') {
          status = 'Assigned';
        }
      }
      this.partnerStatus = status;
    },
    tripPartnerById(id) {
      http
        .get(`v2/partners/triprequests/partner/${id}`)
        .then((response) => {
          this.tripReqPartnerIdData = response.data.data;
          this.pickUpTime = response.data.data.pickUpTime;
          this.selectedTripTypeName = response.data.data.tripType;
          // filter PickUp data from response.data.data.points
          this.pickData = response.data.data.points.filter(
            (point) => point.type === 'PickUp'
          );
          // filter DropOff data from response.data.data.points
          this.dropData = response.data.data.points.filter(
            (point) => point.type === 'DropOff'
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatConfirmPrice() {
      if (
        this.tripReqPartnerIdData.price.trim() === '' ||
        /[a-zA-Z]/g.test(this.tripReqPartnerIdData.price)
      ) {
        this.tripReqPartnerIdData.price = '0';
      }
      this.tripReqPartnerIdData.price = this.tripReqPartnerIdData.price.replace(
        /[^0-9]/g,
        ''
      );
      this.tripReqPartnerIdData.price = numberFormat(
        parseInt(this.tripReqPartnerIdData.price)
      );
    },
    formatConfirmBonus() {
      if (
        this.tripReqPartnerIdData.bonus.trim() === '' ||
        /[a-zA-Z]/g.test(this.tripReqPartnerIdData.bonus)
      ) {
        this.tripReqPartnerIdData.bonus = '0';
      }
      this.tripReqPartnerIdData.bonus = this.tripReqPartnerIdData.bonus.replace(
        /[^0-9]/g,
        ''
      );
      this.tripReqPartnerIdData.bonus = numberFormat(
        parseInt(this.tripReqPartnerIdData.bonus)
      );
    },
    editContractDetails(id, pId) {
      localStorage.setItem('contractDetailStatus', 'contractDetailEdit');
      this.confirmButton(pId, id);
      this.selectedContractId = id;
      this.selectedContractPId = pId;
      http
        .get(`v2/partners/triprequests/partner/${id}`)
        .then((response) => {
          this.contractDetails = response.data.data;

          this.contractFormData.total_price = this.contractDetails.price;
          this.contractFormData.total_price =
            this.contractFormData.total_price.split('.')[0];

          // this.contractFormData.total_price = numberFormat(
          //   this.contractFormData.total_price
          // );

          var calculateOtherBonus = this.contractDetails.tripRequestBonus
            ?.map((item) => {
              return item.base_bonus;
            })
            .reduce((cur, prev) => cur + prev, 0);

          this.contractFormData.bonus = calculateOtherBonus
            ? calculateOtherBonus
            : this.contractDetails.bonus.split('.')[0];

          this.contractFormData.bonus = numberFormat(
            this.contractFormData.bonus
          );

          let homePick = this.contractDetails.pickUpTime[0].time.split(':')[0];
          let homePickMin =
            this.contractDetails.pickUpTime[0].time.split(':')[1];
          this.contractFormData.home = `${homePick}:${homePickMin}`;

          let officePick =
            this.contractDetails.pickUpTime[1].time.split(':')[0];
          let officePickMin =
            this.contractDetails.pickUpTime[1].time.split(':')[1];
          this.contractFormData.office = `${officePick}:${officePickMin}`;

          this.contractFormData.work_week_days = `${this.contractDetails.week_days}(${this.contractDetails.working_days} days)`;

          this.contractFormData.tripType = this.tripTypes.find(
            (tripType) => tripType.name === this.contractDetails.tripType
          ).id;

          this.contractFormData.price = this.contractDetails.trip_per_price;
          this.contractFormData.rm = this.contractDetails.instruction_for_tm;
          this.contractFormData.sp = this.contractDetails.instruction_for_sp;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // contractSubmitHandler() {
    //   let splitWeekDays = this.contractFormData.work_week_days.split('(');
    //   this.contractFormData.week_days = splitWeekDays[0];
    //   this.contractFormData.working_days = splitWeekDays[1].split(' ')[0];
    //   let pickup_time = [
    //     { time: this.contractFormData.home, type: 'HomePickUp' },
    //     { time: this.contractFormData.office, type: 'OfficePickUp' }
    //   ];
    //   let contractData = {
    //     trip_request_to_partner_id: this.selectedContractId,
    //     bonus: this.contractFormData.bonus.split(',').join(''),
    //     price: this.contractFormData.total_price.split(',').join(''),
    //     working_days: this.contractFormData.working_days,
    //     week_days: this.contractFormData.week_days,
    //     tripType: this.contractFormData.tripType,
    //     instruction_for_tm: this.contractFormData.rm,
    //     instruction_for_sp: this.contractFormData.sp,
    //     pickUpTime: [...pickup_time]
    //   };
    //   http
    //     .put(
    //       `/partners/triprequests/invitations/${this.selectedContractPId}`,
    //       contractData
    //     )
    //     .then((response) => {
    //       if (response.status === 200) {
    //         this.alert({
    //           text: 'Contract updated successfully',
    //           icon: 'success'
    //         });
    //         this.getTripRequest();
    //       }
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },
    formatContractPrice() {
      if (
        this.contractFormData.total_price.trim() === '' ||
        /[a-zA-Z]/g.test(this.contractFormData.total_price)
      ) {
        this.contractFormData.total_price = '0';
      }

      this.contractFormData.total_price =
        this.contractFormData.total_price.replace(/[^0-9]/g, '');
      this.contractFormData.total_price = numberFormat(
        parseInt(this.contractFormData.total_price)
      );
    },
    formatContractBonus() {
      if (
        this.contractFormData.bonus.trim() === '' ||
        /[a-zA-Z]/g.test(this.contractFormData.bonus)
      ) {
        this.contractFormData.bonus = '0';
      }

      this.contractFormData.bonus = this.contractFormData.bonus.replace(
        /[^0-9]/g,
        ''
      );
      this.contractFormData.bonus = numberFormat(
        parseInt(this.contractFormData.bonus)
      );
    },
    tripStatusChange(e) {
      e.preventDefault();
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to change the status of this trip?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, change it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          http
            .put(
              'v2/partners/triprequests/status/' + `${this.$route.params.id}`,
              {
                status: e.target.value
              }
            )
            .then(() => {
              this.getTripRequest();
              location.reload();
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.getTripRequest();
        }
      });
    },
    redirectToInvitePartnerPage() {
      let trip = {
        tripRequest: {
          id: this.$route.params.id
        }
      };
      window.localStorage.setItem('trip', JSON.stringify(trip));
      // this.$router.push({ name: 'partners' });
      this.$router.push({ path: '/trip-request/partners' });
    },
    getDriverDetails(id) {
      userService
        .get(`v1/users?user_code=${id.join(',')}`)
        .then((response) => {
          this.driverDetails = response.data.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchData() {
      this.isLoading = true;
      this.user_code = [];

      // if ((this.user_service.name == 'null') && (this.user_service.mobile == 'null')) {
      //   this.getTripRequest();
      // }

      if (
        this.user_service?.name &&
        Object.keys(this.user_service.name).length != 0
      ) {
        var url = `v1/users/search?field=name&return=mobile,name,user_code&key=${
          this.user_service.name || ''
        }`;
        userService
          .get(url)
          .then((response) => {
            let user_info = response.data.data;
            user_info.forEach((users) => {
              this.user_code.push(users.user_code);
            });
            if (this.user_code.length != 0) {
              this.getTripRequest();
            }
            this.invitedPartnerList.length = 0;
            this.isLoading = false;
            this.totalPages = 0;
            this.total = 0;
            this.currentPage = 1;
            this.perPage = 0;
            this.to = 0;
            this.from = 0;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.getTripRequest();
      }
      if (
        this.user_service?.mobile &&
        Object.keys(this.user_service.mobile).length != 0
      ) {
        url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${
          this.user_service.mobile || ''
        }`;
        userService
          .get(url)
          .then((response) => {
            let user_info = response.data.data;
            user_info.forEach((users) => {
              this.user_code.push(users.user_code);
            });
            if (this.user_code.length != 0) {
              this.getTripRequest();
            }
            this.invitedPartnerList.length = 0;
            this.isLoading = false;
            this.totalPages = 0;
            this.total = 0;
            this.currentPage = 1;
            this.perPage = 0;
            this.to = 0;
            this.from = 0;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.getTripRequest();
      }
    },
    checkAssignedStatus(partner_id, iplId) {
      http
        .get(
          `v2/partners/triprequests/status/check/${this.$route.params.id}?status=Assigned`
        )
        .then((response) => {
          this.tripRequestStatusCheck.status = response.data.data.statusExists;
          if (this.tripRequestStatusCheck.status) {
            this.$swal({
              title: 'Are you sure?',
              text: 'This trip already assigned!',
              icon: 'warning',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, Assigned!'
            }).then((result) => {
              if (result.value) {
                document
                  .getElementById('confirm-modal-show')
                  .setAttribute('style', 'display:block');
                this.modalShow = true;
                this.confirmButton(partner_id, iplId);
              }
            });
          } else {
            // this.$swal({
            //   title: 'Trip Assigned!',
            //   text: 'Your trip has assigned successfully!',
            //   icon: 'warning',
            //   type: 'warning'
            // });
            this.modalShow = true;
            document
              .getElementById('confirm-modal-show')
              .setAttribute('style', 'display:block');
            this.confirmButton(partner_id, iplId);
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    }
  },
  computed: {
    sumBonusAmount() {
      // return this.tripRequest?.trip_request_bonus?.map((item) => {
      //   console.log(item);
      //   return item.base_bonus;
      // }).reduce((cur, prev) => cur + prev, 0) || 0;

      var sum = 0;
      this.tripRequest?.trip_request_bonus?.forEach((item) => {
        if (
          item.bonus.bonus_name === 'Shuttle Bonus' &&
          item.type === 'percentage'
        ) {
          sum = Math.round(
            sum + (this.tripRequest.price * item.base_bonus) / 100
          );
        }
        if (item.bonus.bonus_name === 'Shuttle Bonus' && item.type === 'flat') {
          sum = Math.round(sum + item.base_bonus);
        }
        if (item.bonus.bonus_name === 'Completion Bonus') {
          sum = Math.round(sum + item.base_bonus);
        }
      });
      return sum;
    },
    formatWorkDays() {
      return `${this.tripReqPartnerIdData.week_days}(${this.tripReqPartnerIdData.working_days} days)`;
    },
    calculateColPick() {
      if (this.pickData.length > 6) {
        return 'col-2';
      }
      return 'col-' + Math.floor(12 / this.pickData.length);
    },
    calculateColDrop() {
      if (this.dropData.length > 6) {
        return 'col-2';
      }
      return 'col-' + Math.floor(12 / this.dropData.length);
    },
    styleCal() {
      if (this.pickData.length === 5 && this.dropData.length === 5) {
        return '--bs-gutter-x: 0; width: 48.8rem';
      }
      return '--bs-gutter-x: 0';
    },
    // homePickUpTime() {
    //   let h = '',
    //     m = '';
    //   if (Object.keys(this.pickUpTime).length && this.pickUpTime.length) {
    //     h = this.pickUpTime[0].time.split(':')[0];
    //     m = this.pickUpTime[0].time.split(':')[1];
    //   }
    //   return h + ':' + m;
    // },
    homePickUpTimeFormat() {
      // let timeString = this.homePickUpTime;
      // console.log(Object.keys(this.pickUpTime).length,'----',this.pickUpTime.length);
      // const formatTime = new Date(
      //   '2021-12-01T' + timeString + 'Z'
      // ).toLocaleTimeString('en-US', {
      //   timeZone: 'UTC',
      //   hour12: true,
      //   hour: 'numeric',
      //   minute: 'numeric'
      // });
      // return formatTime;
      let pickTimeFilter = this.pickUpTime.filter(function (item) {
        return item.type == 'HomePickUp';
      });

      return pickTimeFilter
        .map((data) => {
          // let [h, m] = data.time.split(':');
          // let dt = new Date();
          // let d = new Date(Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), +h + 6, +m.split(' ')[0]));
          // return d.toLocaleString('en-US', {
          //   hour: 'numeric',
          //   minute: 'numeric',
          //   hour12: true
          // });
          return data.time;
        })
        .join(',');
    },
    // officePickUpTime() {
    //   let h = '',
    //     m = '';
    //   if (Object.keys(this.pickUpTime).length && this.pickUpTime.length) {
    //     h = this.pickUpTime[1].time.split(':')[0];
    //     m = this.pickUpTime[1].time.split(':')[1];
    //   }
    //   return h + ':' + m;
    // },
    officePickUpTimeFormat() {
      // let timeString = this.officePickUpTime;
      // const formatTime = new Date(
      //   '2021-12-01T' + timeString + 'Z'
      // ).toLocaleTimeString('en-US', {
      //   timeZone: 'UTC',
      //   hour12: true,
      //   hour: 'numeric',
      //   minute: 'numeric'
      // });
      // return formatTime;
      let officeTimeFilter = this.pickUpTime.filter(function (item) {
        return item.type == 'OfficePickUp';
      });
      return officeTimeFilter
        .map((data) => {
          // let [h, m] = data.time.split(':');
          // let dt = new Date();
          // let d = new Date(Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), +h + 6, +m.split(' ')[0]));
          // return d.toLocaleString('en-US', {
          //   hour: 'numeric',
          //   minute: 'numeric',
          //   hour12: true
          // });
          return data.time;
        })
        .join(',');
    },
    tripTypeSelection() {
      let trip = {};
      if (Object.keys(this.tripRequestModalData).length) {
        trip = this.tripTypes.find(
          (trip) => trip.name === this.tripRequestModalData.tripType
        );
      }
      return Object.keys(trip).length && trip.id;
    },
    pickLength() {
      return this.pickupData.length - 1;
    },
    dropLength() {
      return this.dropoffData.length - 1;
    },
    // tripHomeTimeFormatData() {
    //   let h = '',
    //     m = '';
    //
    //   if (Object.keys(this.timePick).length && this.timePick.length) {
    //     h = this.timePick[0].time.split(':')[0];
    //     m = this.timePick[0].time.split(':')[1];
    //   }
    //   return new Date('2021-12-01T' + `${h}:${m}` + 'Z').toLocaleTimeString(
    //     'en-US',
    //     {
    //       timeZone: 'UTC',
    //       hour12: true,
    //       hour: 'numeric',
    //       minute: 'numeric'
    //     }
    //   );
    // },
    tripHomeTimeFormatData() {
      return this.homePickTime
        .map((data) => {
          return data.time;
        })
        .join(',');
    },

    tripOfficeTimeFormatData() {
      // return this.officePickTime.map((data) => {
      //   console.log(data.time)
      //   let [h, m] = data.time.split(':');
      //   let dt = new Date();
      //   let d = new Date(Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), +h + 6, +m.split(' ')[0]));
      //   return d.toLocaleString('en-US', {
      //     hour: 'numeric',
      //     minute: 'numeric',
      //     hour12: true
      //   });
      // }).join(',').toString();
      return this.officePickTime
        .map((data) => {
          return data.time;
        })
        .join(',');
    },
    remarkValidation() {
      if (
        this.remarksForm.remarks.length &&
        this.remarksForm.preset_remark_id
        //  this.remarksForm.remarked_by.length
      ) {
        return false;
      }
      return true;
    },
    talkedValidation() {
      if (
        // this.callDetailsFrom.called_by
        // &&
        this.callDetailsFrom.call_notes_id
      ) {
        return false;
      }
      return true;
    },
    formatPrice() {
      return numberFormat(parseInt(this.tripReqPartnerIdData.price));
    },
    isContractFormDataValid() {
      if (
        this.contractFormData.total_price.length > 0 &&
        this.contractFormData.bonus.length > 0 &&
        this.contractFormData.home.length > 0 &&
        this.contractFormData.office.length > 0 &&
        this.contractFormData.work_week_days.length > 0 &&
        this.contractFormData.tripType
      ) {
        return true;
      }
      return false;
    },
    priceConvertToWord() {
      return numberInWord(+this.tripRequest.price);
    },
    priceBonusToWord() {
      return numberInWord(+this.tripRequest.bonus);
    },
    getBonusWithPrice() {
      // return this.tripRequest?.trip_request_bonus
      //   ?.map((item) => {
      //     if (item.bonus.bonus_name === 'Completion Bonus') {
      //       return `${item.bonus.bonus_name} - ${item.base_bonus}`;
      //     }
      //     // if (item.type === 'percentage') {
      //     //   return `${item.bonus.bonus_name} : ${item.type} -- ${this.tripRequest.price * item.base_bonus / 100}`;
      //     //
      //     // } else {
      //     //   return `${item.bonus.bonus_name} : ${item.type} -- ${item.base_bonus}`;
      //     // }
      //   })
      //   .toString()
      //   .split(',')[0];

      let completionBonus = '';

      if (this.tripRequest && this.tripRequest.trip_request_bonus) {
        this.tripRequest.trip_request_bonus.forEach((item) => {
          if (item.bonus?.bonus_name === 'Completion Bonus') {
            completionBonus = `${item.bonus.bonus_name} - ${item.base_bonus}`;
            completionBonus = completionBonus.toString().split(',')[0];
          }
        });
      }

      return completionBonus;
    },
    getDailyBonusCalculation() {
      return this.tripRequest?.trip_request_bonus
        ?.map((item) => {
          if (
            item.bonus.bonus_name === 'Shuttle Bonus' &&
            item.type === 'percentage'
          ) {
            return `${item.bonus.bonus_name} (${
              item.base_bonus + '%'
            }) ${Math.round(
              (this.tripRequest.trip_per_price *
                this.tripRequest.distance *
                (this.officePickTime.length + this.homePickTime.length) *
                this.tripRequest.working_days +
                (this.tripRequest.trip_per_price *
                  this.tripRequest.distance *
                  (this.officePickTime.length + this.homePickTime.length) *
                  this.tripRequest.working_days *
                  item.base_bonus) /
                  100) /
                this.tripRequest.working_days
            )} BDT`;
          }
          if (
            item.bonus.bonus_name === 'Shuttle Bonus' &&
            item.type === 'flat'
          ) {
            return `${item.bonus.bonus_name} ${item.type}  ${Math.round(
              (this.tripRequest.trip_per_price *
                this.tripRequest.distance *
                (this.officePickTime.length + this.homePickTime.length) *
                this.tripRequest.working_days +
                item.base_bonus) /
                this.tripRequest.working_days
            )} BDT`;
          }
        })
        .toString()
        .replace(/,/g, '');
    },
    getWeeklyBonusCalculation() {
      return this.tripRequest?.trip_request_bonus
        ?.map((item) => {
          if (
            item.bonus.bonus_name === 'Shuttle Bonus' &&
            item.type === 'percentage'
          ) {
            return `${item.bonus.bonus_name} (${
              item.base_bonus + '%'
            })  ${Math.round(
              this.tripRequest.trip_per_price *
                this.tripRequest.distance *
                (this.homePickTime.length + this.officePickTime.length) *
                this.tripRequest.working_days +
                this.tripRequest.trip_per_price *
                  this.tripRequest.distance *
                  (this.homePickTime.length + this.officePickTime.length) *
                  this.tripRequest.working_days *
                  (item.base_bonus / 100)
            )} BDT`;
          }
          if (
            item.bonus.bonus_name === 'Shuttle Bonus' &&
            item.type === 'flat'
          ) {
            return `${item.bonus.bonus_name} ${item.type} ${Math.round(
              this.tripRequest.trip_per_price *
                this.tripRequest.distance *
                (this.officePickTime.length + this.homePickTime.length) *
                this.tripRequest.working_days +
                item.base_bonus
            )}`;
          }
        })
        .toString()
        .replace(/,/g, '');
    }
  },
  unmounted() {
    window.localStorage.removeItem('pId');
    window.localStorage.removeItem('id');
  }
};
</script>

<style scoped>
.trip-details {
  margin-top: 15px;
}

.partner-stats {
  margin-top: 15px;
}

.border {
  background-color: white;
  text-align: left;
  padding: 10px 0px 0px 15px;
}

.col-md-3.decline {
  border-right: none;
}

.state {
  background-color: white;
  border: 1px solid #ddd;
  text-align: left;
}

.status {
  padding: 10px 0px 0px 15px;
}

.row > * {
  padding-left: 0 !important;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.bi {
  cursor: pointer;
}

.table thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #ffffff;
  background: #f3f3f3;
}

.contract-text {
  margin-top: 10px;
  color: #000000;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
}

.contract-deal {
  display: flex;
}

.contract-deal-text {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  margin-top: 10px;
  color: #999999;
}

.contract-deal-icon {
  margin: -2px 15px;
  margin-top: 8px;
  padding: 0;
}

.remarks {
  margin-top: 10px;
  color: #000000;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
}

.remarks-section {
  display: flex;
  margin: 0px;
}

.remarks-text {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  margin-top: 10px;
  color: #999999;
}

.remarks-icons {
  margin: -2px 10px;
  margin-top: 8px;
  padding: 0;
}

.bi-plus::before {
  margin-right: 10px;
  padding: 4px 4px;
  font-size: 16px;
  background: #dddcdc;
  border-radius: 100px;
}

.bi-eye::before {
  margin-right: 10px;
  padding: 4px 4px;
  font-size: 16px;
  background: #dddcdc;
  border-radius: 100px;
}

.talk {
  margin-top: 10px;
  color: #000000;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
}

.talk-section {
  display: flex;
  margin: 0px;
}

.talk-text {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  margin-top: 10px;
  color: #999999;
}

.talk-icons {
  margin: -2px 15px;
  margin-top: 8px;
  padding: 0;
}

.confirm-text {
  margin-top: 10px;
  color: #000000;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
}

.confirm-button {
  background: #262c66;
  border: none;
  height: 30px;
  border-radius: 8px;
  color: #ffffff;
  width: 35%;
  text-align: center;
}

.confirm-unassigned-button {
  background: red;
  border: none;
  height: 30px;
  border-radius: 8px;
  color: #ffffff;
  width: 37%;
  text-align: center;
}

.sms-resand {
  background: blue;
  border: none;
  height: 30px;
  border-radius: 8px;
  color: #ffffff;
  width: 37%;
  text-align: center;
}

.input-group {
  width: 15.2rem;
}

#remark-detail-table thead tr,
th {
  background-color: #f0f2f5;
}

#remark-detail-table #conversion-detail-table {
  font-family: Montserrat;
  font-size: 12px;
  line-height: 12px;
}

#remarkDetailsLabel,
#conversionCreateLabel {
  font-family: Montserrat;
}

.contacts-row {
  display: flex;
  width: 100%;
}

.dots {
  display: inline-flex;
  background: radial-gradient(circle, #c4c4c4 2px, transparent 2px) repeat-x;
  background-size: 10px 25px;
  border: none;
  flex-grow: 5;
  margin-top: 4px;
}

.dots:after {
  display: inline-flex;
  background: radial-gradient(circle, #c4c4c4 2px, transparent 2px) repeat-x;
  background-size: 10px 25px;
  border: none;
  flex-grow: 5;
}

.bi-geo-alt-fill,
.bi-record-circle-fill {
  color: #262c66;
  margin-bottom: 5px;
}

.bi-geo-alt-fill:before {
  font-size: 18px;
}

.confirm-modal {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 4rem;
  width: 44rem;
}

.confirm-modal .edit-info {
  background: none;
  color: #0d0d0d;
  margin-left: 130px;
}

.confirm-modal .confirm-submit-button {
  width: 12.2rem;
  background: #262c66;
  border-radius: 4px;
  color: #fff;
  margin: 1rem 6rem;
  font-size: 1rem;
}

.confirm-modal a {
  color: #ffffff;
  font-size: 1rem;
  text-decoration: none;
}

.edit {
  outline: none;
  border: 1px solid #a5b9f1 !important;
  font-size: 14px !important;
  padding: 5px !important;
  background: url('http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png')
    white no-repeat 98.5% !important;
  background: url('http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png')
    white no-repeat calc(100% - 10px) !important;
}

.form-control-plaintext {
  background: transparent !important;
}

.confirm-select {
  border: none;
  background: none;
  padding: 2px;
}

.row-click {
  cursor: pointer;
}

#remarksSubmitBtn {
  background-color: #1c2457;
  border-color: #1c2457;
}

#callSubmitBtn {
  background-color: #1c2457;
  border-color: #1c2457;
}

.contract-button {
  background-color: #262c66;
  color: #f0f2f5;
  border: 1px solid #262c66;
  border-radius: 4px;
}

.global-search-button {
  background: #1c2457;
}
</style>
